/* eslint-disable */
// Compiled Excel actual data for the JAR Dashboard
export const JARActualData = {
  "contraceptive_prevalence_rate": {
    "2013": {
      "NDHS": {
        "states": [
          {
            "state": "Nasarawa",
            "value": 18.1
          },
          {
            "state": "Kogi",
            "value": 10.5
          },
          {
            "state": "FCT",
            "value": 25.2
          },
          {
            "state": "Benue",
            "value": 16.5
          },
          {
            "state": "Kwara",
            "value": 40.2
          },
          {
            "state": "Niger",
            "value": 6.6
          },
          {
            "state": "Plateau",
            "value": 15.2
          },
          {
            "state": "Adamawa",
            "value": 4.4
          },
          {
            "state": "Bauchi",
            "value": 2.2
          },
          {
            "state": "Borno",
            "value": 1.8
          },
          {
            "state": "Gombe",
            "value": 4.0
          },
          {
            "state": "Taraba",
            "value": 8.0
          },
          {
            "state": "Yobe",
            "value": 1.1
          },
          {
            "state": "Jigawa",
            "value": 0.9
          },
          {
            "state": "Kano",
            "value": 0.6
          },
          {
            "state": "Abia",
            "value": 33.4
          },
          {
            "state": "Anambra",
            "value": 35.0
          },
          {
            "state": "Ebonyi",
            "value": 15.7
          },
          {
            "state": "Enugu",
            "value": 31.4
          },
          {
            "state": "Imo",
            "value": 34.1
          },
          {
            "state": "Akwa Ibom",
            "value": 25.5
          },
          {
            "state": "Bayelsa",
            "value": 13.3
          },
          {
            "state": "Cross River",
            "value": 24.0
          },
          {
            "state": "Delta",
            "value": 28.7
          },
          {
            "state": "Edo",
            "value": 30.3
          },
          {
            "state": "Rivers",
            "value": 34.5
          },
          {
            "state": "Ekiti",
            "value": 34.5
          },
          {
            "state": "Lagos",
            "value": 48.3
          },
          {
            "state": "Ogun",
            "value": 26.0
          },
          {
            "state": "Ondo",
            "value": 31.1
          },
          {
            "state": "Osun",
            "value": 38.3
          },
          {
            "state": "Oyo",
            "value": 37.4
          },
          {
            "state": "Kebbi",
            "value": 1.3
          },
          {
            "state": "Sokoto",
            "value": 1.1
          },
          {
            "state": "Zamfara",
            "value": 3.0
          },
          {
            "state": "Kaduna",
            "value": 20.2
          },
          {
            "state": "Katsina",
            "value": 1.3
          }
        ],
        "national": [
          {
            "state": "2013",
            "value": 16.0
          },
          {
            "state": "North-Central",
            "value": 15.6
          },
          {
            "state": "North-East",
            "value": 3.2
          },
          {
            "state": "North-West",
            "value": 4.3
          },
          {
            "state": "South-South",
            "value": 28.1
          },
          {
            "state": "South-West",
            "value": 38.0
          },
          {
            "state": "South-East",
            "value": 29.3
          }
        ]
      }
    },
    "1999": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "1999",
            "value": 15.3
          },
          {
            "state": "North-West",
            "value": 3.2
          },
          {
            "state": "South-East",
            "value": 23.5
          },
          {
            "state": "South-West",
            "value": 26.2
          },
          {
            "state": "North-Central",
            "value": 17.8
          },
          {
            "state": "North-East",
            "value": 3.1
          }
        ]
      }
    },
    "2008": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "2008",
            "value": 15.4
          },
          {
            "state": "North-Central",
            "value": 13.0
          },
          {
            "state": "North-East",
            "value": 4.0
          },
          {
            "state": "North-West",
            "value": 2.8
          },
          {
            "state": "South-East",
            "value": 23.4
          },
          {
            "state": "South-South",
            "value": 26.2
          },
          {
            "state": "South-West",
            "value": 31.7
          }
        ]
      }
    },
    "2018": {
      "NDHS": {
        "states": [
          {
            "state": "FCT",
            "value": 23.6
          },
          {
            "state": "Benue",
            "value": 17.1
          },
          {
            "state": "Kogi",
            "value": 18.3
          },
          {
            "state": "Kwara",
            "value": 22.4
          },
          {
            "state": "Nasarawa",
            "value": 14.8
          },
          {
            "state": "Niger",
            "value": 7.6
          },
          {
            "state": "Plateau",
            "value": 22.7
          },
          {
            "state": "Adamawa",
            "value": 25.1
          },
          {
            "state": "Bauchi",
            "value": 6.5
          },
          {
            "state": "Borno",
            "value": 6.2
          },
          {
            "state": "Gombe",
            "value": 17.0
          },
          {
            "state": "Taraba",
            "value": 10.3
          },
          {
            "state": "Yobe",
            "value": 1.9
          },
          {
            "state": "Jigawa",
            "value": 4.0
          },
          {
            "state": "Kaduna",
            "value": 14.9
          },
          {
            "state": "Kano",
            "value": 6.3
          },
          {
            "state": "Katsina",
            "value": 3.4
          },
          {
            "state": "Kebbi",
            "value": 3.5
          },
          {
            "state": "Sokoto",
            "value": 2.3
          },
          {
            "state": "Zamfara",
            "value": 7.3
          },
          {
            "state": "Abia",
            "value": 12.9
          },
          {
            "state": "Anambra",
            "value": 44.6
          },
          {
            "state": "Ebonyi",
            "value": 8.2
          },
          {
            "state": "Enugu",
            "value": 30.9
          },
          {
            "state": "Imo",
            "value": 30.7
          },
          {
            "state": "Rivers",
            "value": 32.0
          },
          {
            "state": "Ekiti",
            "value": 38.5
          },
          {
            "state": "Lagos",
            "value": 49.4
          },
          {
            "state": "Ogun",
            "value": 32.1
          },
          {
            "state": "Ondo",
            "value": 20.1
          },
          {
            "state": "Osun",
            "value": 29.4
          },
          {
            "state": "Oyo",
            "value": 22.6
          },
          {
            "state": "Bayelsa",
            "value": 3.7
          },
          {
            "state": "Cross River",
            "value": 20.0
          },
          {
            "state": "Delta",
            "value": 16.5
          },
          {
            "state": "Edo",
            "value": 19.4
          },
          {
            "state": "Akwa Ibom",
            "value": 19.8
          }
        ],
        "national": [
          {
            "state": "South-West",
            "value": 35.1
          },
          {
            "state": "2018",
            "value": 14.3
          },
          {
            "state": "North-Central",
            "value": 16.2
          },
          {
            "state": "North-East",
            "value": 9.5
          },
          {
            "state": "North-West",
            "value": 6.7
          },
          {
            "state": "South-East",
            "value": 28.1
          },
          {
            "state": "South-South",
            "value": 21.7
          }
        ]
      }
    },
    "1990": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "North-East",
            "value": 2.0
          },
          {
            "state": "North-West",
            "value": 1.2
          },
          {
            "state": "South-West",
            "value": 15.0
          },
          {
            "state": "1990",
            "value": 7.5
          },
          {
            "state": "South-East",
            "value": 8.8
          }
        ]
      }
    },
    "2003": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "North-Central",
            "value": 13.3
          },
          {
            "state": "North-East",
            "value": 4.2
          },
          {
            "state": "North-West",
            "value": 4.9
          },
          {
            "state": "South-East",
            "value": 22.5
          },
          {
            "state": "South-South",
            "value": 25.4
          },
          {
            "state": "South-West",
            "value": 32.7
          },
          {
            "state": "2003",
            "value": 13.3
          }
        ]
      }
    },
    "2023": {
      "NDHS": {
        "states": [
          {
            "state": "FCT",
            "value": 21.3
          },
          {
            "state": "Benue",
            "value": 31.3
          },
          {
            "state": "Kogi",
            "value": 13.1
          },
          {
            "state": "Kwara",
            "value": 11.0
          },
          {
            "state": "Nasarawa",
            "value": 25.5
          },
          {
            "state": "Niger",
            "value": 10.3
          },
          {
            "state": "Plateau",
            "value": 31.1
          },
          {
            "state": "Adamawa",
            "value": 20.4
          },
          {
            "state": "Bauchi",
            "value": 11.3
          },
          {
            "state": "Borno",
            "value": 9.5
          },
          {
            "state": "Gombe",
            "value": 30.9
          },
          {
            "state": "Taraba",
            "value": 11.5
          },
          {
            "state": "Yobe",
            "value": 9.0
          },
          {
            "state": "Jigawa",
            "value": 4.4
          },
          {
            "state": "Kaduna",
            "value": 14.2
          },
          {
            "state": "Kano",
            "value": 11.1
          },
          {
            "state": "Katsina",
            "value": 7.7
          },
          {
            "state": "Kebbi",
            "value": 3.3
          },
          {
            "state": "Sokoto",
            "value": 6.9
          },
          {
            "state": "Zamfara",
            "value": 20.0
          },
          {
            "state": "Abia",
            "value": 34.0
          },
          {
            "state": "Edo",
            "value": 27.5
          },
          {
            "state": "Rivers",
            "value": 20.4
          },
          {
            "state": "Ekiti",
            "value": 66.1
          },
          {
            "state": "Lagos",
            "value": 54.2
          },
          {
            "state": "Ogun",
            "value": 39.9
          },
          {
            "state": "Ondo",
            "value": 26.8
          },
          {
            "state": "Osun",
            "value": 40.3
          },
          {
            "state": "Oyo",
            "value": 40.9
          },
          {
            "state": "Ebonyi",
            "value": 9.9
          },
          {
            "state": "Enugu",
            "value": 25.9
          },
          {
            "state": "Imo",
            "value": 44.1
          },
          {
            "state": "Bayelsa",
            "value": 24.6
          },
          {
            "state": "Cross River",
            "value": 27.2
          },
          {
            "state": "Delta",
            "value": 42.3
          },
          {
            "state": "Anambra",
            "value": 41.3
          },
          {
            "state": "Akwa Ibom",
            "value": 43.2
          }
        ],
        "national": [
          {
            "state": "South-West",
            "value": 43.9
          },
          {
            "state": "North-Central",
            "value": 19.4
          },
          {
            "state": "North-East",
            "value": 13.9
          },
          {
            "state": "North-West",
            "value": 10.3
          },
          {
            "state": "South-East",
            "value": 29.8
          },
          {
            "state": "South-South",
            "value": 30.8
          },
          {
            "state": "2023",
            "value": 20.3
          }
        ]
      }
    }
  },
  "antenatal_care_coverage": {
    "2013": {
      "NDHS": {
        "states": [
          {
            "state": "FCT",
            "value": 85.8
          },
          {
            "state": "Benue",
            "value": 36.6
          },
          {
            "state": "Plateau",
            "value": 40.6
          },
          {
            "state": "Adamawa",
            "value": 64.7
          },
          {
            "state": "Bauchi",
            "value": 42.2
          },
          {
            "state": "Borno",
            "value": 26.0
          },
          {
            "state": "Gombe",
            "value": 53.5
          },
          {
            "state": "Taraba",
            "value": 40.2
          },
          {
            "state": "Yobe",
            "value": 19.6
          },
          {
            "state": "Jigawa",
            "value": 34.4
          },
          {
            "state": "Kaduna",
            "value": 44.2
          },
          {
            "state": "Kano",
            "value": 41.2
          },
          {
            "state": "Katsina",
            "value": 23.1
          },
          {
            "state": "Kebbi",
            "value": 18.1
          },
          {
            "state": "Sokoto",
            "value": 16.4
          },
          {
            "state": "Zamfara",
            "value": 17.8
          },
          {
            "state": "Abia",
            "value": 85.5
          },
          {
            "state": "Anambra",
            "value": 76.8
          },
          {
            "state": "Ebonyi",
            "value": 75.8
          },
          {
            "state": "Enugu",
            "value": 92.2
          },
          {
            "state": "Imo",
            "value": 88.5
          },
          {
            "state": "Ekiti",
            "value": 84.2
          },
          {
            "state": "Lagos",
            "value": 92.0
          },
          {
            "state": "Ogun",
            "value": 90.6
          },
          {
            "state": "Ondo",
            "value": 79.8
          },
          {
            "state": "Osun",
            "value": 94.7
          },
          {
            "state": "Oyo",
            "value": 79.9
          },
          {
            "state": "Akwa Ibom",
            "value": 55.2
          },
          {
            "state": "Cross River",
            "value": 75.8
          },
          {
            "state": "Delta",
            "value": 74.2
          },
          {
            "state": "Edo",
            "value": 69.7
          },
          {
            "state": "Rivers",
            "value": 53.0
          },
          {
            "state": "Kwara",
            "value": 84.8
          },
          {
            "state": "Nasarawa",
            "value": 58.2
          },
          {
            "state": "Niger",
            "value": 50.1
          },
          {
            "state": "Kogi",
            "value": 85.2
          },
          {
            "state": "Bayelsa",
            "value": 33.8
          }
        ],
        "national": [
          {
            "state": "2013",
            "value": 51.1
          },
          {
            "state": "North-Central",
            "value": 55.5
          },
          {
            "state": "North-East",
            "value": 38.9
          },
          {
            "state": "North-West",
            "value": 30.4
          },
          {
            "state": "South-East",
            "value": 82.9
          },
          {
            "state": "South-West",
            "value": 86.9
          },
          {
            "state": "South-South",
            "value": 62.3
          }
        ]
      }
    },
    "2008": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "2008",
            "value": 44.8
          },
          {
            "state": "North-Central",
            "value": 48.3
          },
          {
            "state": "North-East",
            "value": 32.4
          },
          {
            "state": "North-West",
            "value": 20.6
          },
          {
            "state": "South-East",
            "value": 60.9
          },
          {
            "state": "South-West",
            "value": 80.7
          },
          {
            "state": "South-South",
            "value": 53.3
          }
        ]
      }
    },
    "1999": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "1999",
            "value": 47.3
          }
        ]
      }
    },
    "1990": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "North-East",
            "value": 25.0
          },
          {
            "state": "North-West",
            "value": 33.5
          },
          {
            "state": "South-East",
            "value": 67.3
          },
          {
            "state": "South-West",
            "value": 83.9
          },
          {
            "state": "1990",
            "value": 50.9
          }
        ]
      }
    },
    "2003": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "North-Central",
            "value": 55.7
          },
          {
            "state": "North-East",
            "value": 32.5
          },
          {
            "state": "North-West",
            "value": 28.6
          },
          {
            "state": "South-East",
            "value": 72.2
          },
          {
            "state": "South-West",
            "value": 92.8
          },
          {
            "state": "South-South",
            "value": 68.1
          },
          {
            "state": "2003",
            "value": 47.4
          }
        ]
      }
    },
    "2018": {
      "NDHS": {
        "states": [
          {
            "state": "FCT",
            "value": 71.6
          },
          {
            "state": "Benue",
            "value": 56.3
          },
          {
            "state": "Kogi",
            "value": 71.2
          },
          {
            "state": "Kwara",
            "value": 66.0
          },
          {
            "state": "Nasarawa",
            "value": 67.3
          },
          {
            "state": "Niger",
            "value": 33.0
          },
          {
            "state": "Plateau",
            "value": 55.1
          },
          {
            "state": "Adamawa",
            "value": 66.5
          },
          {
            "state": "Bauchi",
            "value": 42.3
          },
          {
            "state": "Borno",
            "value": 34.4
          },
          {
            "state": "Gombe",
            "value": 44.4
          },
          {
            "state": "Taraba",
            "value": 49.9
          },
          {
            "state": "Yobe",
            "value": 35.8
          },
          {
            "state": "Jigawa",
            "value": 47.9
          },
          {
            "state": "Kaduna",
            "value": 54.1
          },
          {
            "state": "Kano",
            "value": 51.0
          },
          {
            "state": "Katsina",
            "value": 38.4
          },
          {
            "state": "Kebbi",
            "value": 27.4
          },
          {
            "state": "Sokoto",
            "value": 30.7
          },
          {
            "state": "Zamfara",
            "value": 25.9
          },
          {
            "state": "Imo",
            "value": 86.2
          },
          {
            "state": "Ekiti",
            "value": 86.4
          },
          {
            "state": "Lagos",
            "value": 80.2
          },
          {
            "state": "Ogun",
            "value": 90.9
          },
          {
            "state": "Ondo",
            "value": 84.3
          },
          {
            "state": "Osun",
            "value": 95.6
          },
          {
            "state": "Oyo",
            "value": 79.5
          },
          {
            "state": "Akwa Ibom",
            "value": 65.1
          },
          {
            "state": "Bayelsa",
            "value": 25.9
          },
          {
            "state": "Cross River",
            "value": 65.7
          },
          {
            "state": "Delta",
            "value": 71.7
          },
          {
            "state": "Edo",
            "value": 71.9
          },
          {
            "state": "Rivers",
            "value": 81.2
          },
          {
            "state": "Anambra",
            "value": 82.5
          },
          {
            "state": "Ebonyi",
            "value": 74.2
          },
          {
            "state": "Enugu",
            "value": 88.1
          },
          {
            "state": "Abia",
            "value": 89.2
          }
        ],
        "national": [
          {
            "state": "North-Central",
            "value": 54.2
          },
          {
            "state": "North-East",
            "value": 44.0
          },
          {
            "state": "North-West",
            "value": 42.2
          },
          {
            "state": "South-East",
            "value": 82.9
          },
          {
            "state": "South-West",
            "value": 84.2
          },
          {
            "state": "South-South",
            "value": 69.5
          },
          {
            "state": "2018",
            "value": 56.8
          }
        ]
      }
    },
    "2023": {
      "NDHS": {
        "states": [
          {
            "state": "Benue",
            "value": 49.1
          },
          {
            "state": "Kogi",
            "value": 54.1
          },
          {
            "state": "Kwara",
            "value": 51.3
          },
          {
            "state": "Nasarawa",
            "value": 66.0
          },
          {
            "state": "Niger",
            "value": 34.7
          },
          {
            "state": "Plateau",
            "value": 46.4
          },
          {
            "state": "Adamawa",
            "value": 56.4
          },
          {
            "state": "Bauchi",
            "value": 46.6
          },
          {
            "state": "Borno",
            "value": 61.1
          },
          {
            "state": "Gombe",
            "value": 39.1
          },
          {
            "state": "Taraba",
            "value": 50.5
          },
          {
            "state": "Yobe",
            "value": 48.5
          },
          {
            "state": "Jigawa",
            "value": 37.7
          },
          {
            "state": "Kaduna",
            "value": 59.4
          },
          {
            "state": "Kano",
            "value": 51.3
          },
          {
            "state": "Katsina",
            "value": 37.2
          },
          {
            "state": "Kebbi",
            "value": 14.0
          },
          {
            "state": "Sokoto",
            "value": 22.7
          },
          {
            "state": "Abia",
            "value": 79.1
          },
          {
            "state": "Anambra",
            "value": 84.9
          },
          {
            "state": "Ebonyi",
            "value": 61.7
          },
          {
            "state": "Enugu",
            "value": 61.9
          },
          {
            "state": "Imo",
            "value": 84.9
          },
          {
            "state": "Akwa Ibom",
            "value": 65.7
          },
          {
            "state": "Bayelsa",
            "value": 48.6
          },
          {
            "state": "Cross River",
            "value": 80.0
          },
          {
            "state": "Delta",
            "value": 60.5
          },
          {
            "state": "Edo",
            "value": 63.0
          },
          {
            "state": "Rivers",
            "value": 76.5
          },
          {
            "state": "Oyo",
            "value": 73.8
          },
          {
            "state": "Lagos",
            "value": 95.4
          },
          {
            "state": "Ogun",
            "value": 73.7
          },
          {
            "state": "Ondo",
            "value": 66.3
          },
          {
            "state": "Osun",
            "value": 92.0
          },
          {
            "state": "FCT",
            "value": 79.9
          },
          {
            "state": "Ekiti",
            "value": 68.6
          },
          {
            "state": "Zamfara",
            "value": 21.5
          }
        ],
        "national": [
          {
            "state": "North-Central",
            "value": 50.3
          },
          {
            "state": "North-East",
            "value": 50.6
          },
          {
            "state": "North-West",
            "value": 40.6
          },
          {
            "state": "South-East",
            "value": 73.6
          },
          {
            "state": "South-South",
            "value": 67.1
          },
          {
            "state": "South-West",
            "value": 80.8
          },
          {
            "state": "2023",
            "value": 52.4
          }
        ]
      }
    }
  },
  "skilled_birth_attendance": {
    "2013": {
      "NDHS": {
        "states": [
          {
            "state": "FCT",
            "value": 70.2
          },
          {
            "state": "Benue",
            "value": 51.6
          },
          {
            "state": "Kogi",
            "value": 70.9
          },
          {
            "state": "Kwara",
            "value": 79.6
          },
          {
            "state": "Nasarawa",
            "value": 40.7
          },
          {
            "state": "Niger",
            "value": 28.6
          },
          {
            "state": "Plateau",
            "value": 35.8
          },
          {
            "state": "Adamawa",
            "value": 36.3
          },
          {
            "state": "Bauchi",
            "value": 16.3
          },
          {
            "state": "Borno",
            "value": 22.3
          },
          {
            "state": "Gombe",
            "value": 26.6
          },
          {
            "state": "Taraba",
            "value": 14.3
          },
          {
            "state": "Jigawa",
            "value": 7.6
          },
          {
            "state": "Kaduna",
            "value": 35.5
          },
          {
            "state": "Kano",
            "value": 13.7
          },
          {
            "state": "Katsina",
            "value": 7.7
          },
          {
            "state": "Kebbi",
            "value": 9.3
          },
          {
            "state": "Sokoto",
            "value": 5.4
          },
          {
            "state": "Zamfara",
            "value": 6.1
          },
          {
            "state": "Abia",
            "value": 77.2
          },
          {
            "state": "Anambra",
            "value": 87.6
          },
          {
            "state": "Ebonyi",
            "value": 62.1
          },
          {
            "state": "Enugu",
            "value": 91.5
          },
          {
            "state": "Imo",
            "value": 96.5
          },
          {
            "state": "Ekiti",
            "value": 84.7
          },
          {
            "state": "Lagos",
            "value": 87.2
          },
          {
            "state": "Ogun",
            "value": 84.7
          },
          {
            "state": "Ondo",
            "value": 67.2
          },
          {
            "state": "Osun",
            "value": 94.2
          },
          {
            "state": "Oyo",
            "value": 78.3
          },
          {
            "state": "Akwa Ibom",
            "value": 45.6
          },
          {
            "state": "Bayelsa",
            "value": 32.1
          },
          {
            "state": "Cross River",
            "value": 41.3
          },
          {
            "state": "Delta",
            "value": 59.8
          },
          {
            "state": "Edo",
            "value": 78.3
          },
          {
            "state": "Rivers",
            "value": 63.4
          },
          {
            "state": "Yobe",
            "value": 10.2
          }
        ],
        "national": [
          {
            "state": "2013",
            "value": 38.1
          },
          {
            "state": "South-South",
            "value": 55.4
          },
          {
            "state": "North-Central",
            "value": 46.5
          },
          {
            "state": "North-East",
            "value": 19.9
          },
          {
            "state": "North-West",
            "value": 12.3
          },
          {
            "state": "South-East",
            "value": 82.2
          },
          {
            "state": "South-West",
            "value": 82.5
          }
        ]
      }
    },
    "2008": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "South-South",
            "value": 55.8
          },
          {
            "state": "2008",
            "value": 38.9
          },
          {
            "state": "North-Central",
            "value": 42.7
          },
          {
            "state": "North-East",
            "value": 15.5
          },
          {
            "state": "North-West",
            "value": 9.8
          },
          {
            "state": "South-East",
            "value": 81.8
          },
          {
            "state": "South-West",
            "value": 76.5
          }
        ]
      }
    },
    "1990": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "North-East",
            "value": 11.1
          },
          {
            "state": "North-West",
            "value": 10.2
          },
          {
            "state": "South-West",
            "value": 66.5
          },
          {
            "state": "1990",
            "value": 32.0
          },
          {
            "state": "South-East",
            "value": 47.1
          }
        ]
      }
    },
    "2018": {
      "NDHS": {
        "states": [
          {
            "state": "Abia",
            "value": 95.8
          },
          {
            "state": "Adamawa",
            "value": 40.5
          },
          {
            "state": "Akwa Ibom",
            "value": 41.4
          },
          {
            "state": "Anambra",
            "value": 94.7
          },
          {
            "state": "Bauchi",
            "value": 21.6
          },
          {
            "state": "Bayelsa",
            "value": 27.0
          },
          {
            "state": "Benue",
            "value": 67.6
          },
          {
            "state": "Borno",
            "value": 25.9
          },
          {
            "state": "Cross River",
            "value": 55.7
          },
          {
            "state": "Delta",
            "value": 67.1
          },
          {
            "state": "Ebonyi",
            "value": 52.1
          },
          {
            "state": "Ekiti",
            "value": 87.1
          },
          {
            "state": "Enugu",
            "value": 93.0
          },
          {
            "state": "Gombe",
            "value": 18.8
          },
          {
            "state": "Imo",
            "value": 98.2
          },
          {
            "state": "Jigawa",
            "value": 20.9
          },
          {
            "state": "Kaduna",
            "value": 26.5
          },
          {
            "state": "Kano",
            "value": 21.5
          },
          {
            "state": "Katsina",
            "value": 18.9
          },
          {
            "state": "Kebbi",
            "value": 3.4
          },
          {
            "state": "Kogi",
            "value": 73.4
          },
          {
            "state": "Kwara",
            "value": 62.1
          },
          {
            "state": "Lagos",
            "value": 83.6
          },
          {
            "state": "Nasarawa",
            "value": 57.3
          },
          {
            "state": "Niger",
            "value": 24.7
          },
          {
            "state": "Ogun",
            "value": 79.9
          },
          {
            "state": "Ondo",
            "value": 86.1
          },
          {
            "state": "Osun",
            "value": 96.0
          },
          {
            "state": "Oyo",
            "value": 84.6
          },
          {
            "state": "Plateau",
            "value": 42.9
          },
          {
            "state": "Rivers",
            "value": 78.3
          },
          {
            "state": "Sokoto",
            "value": 9.2
          },
          {
            "state": "Taraba",
            "value": 30.4
          },
          {
            "state": "Yobe",
            "value": 17.8
          },
          {
            "state": "Zamfara",
            "value": 12.5
          },
          {
            "state": "FCT",
            "value": 71.6
          },
          {
            "state": "Edo",
            "value": 88.2
          }
        ],
        "national": [
          {
            "state": "South-West",
            "value": 85.4
          },
          {
            "state": "2018",
            "value": 43.3
          },
          {
            "state": "North-Central",
            "value": 51.0
          },
          {
            "state": "North-East",
            "value": 24.8
          },
          {
            "state": "North-West",
            "value": 18.2
          },
          {
            "state": "South-East",
            "value": 85.2
          },
          {
            "state": "South-South",
            "value": 64.8
          }
        ]
      }
    },
    "2003": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "South-West",
            "value": 80.9
          },
          {
            "state": "North-Central",
            "value": 48.6
          },
          {
            "state": "North-East",
            "value": 19.8
          },
          {
            "state": "North-West",
            "value": 12.3
          },
          {
            "state": "South-South",
            "value": 55.6
          },
          {
            "state": "South-East",
            "value": 87.4
          },
          {
            "state": "2003",
            "value": 35.1
          }
        ]
      }
    },
    "1999": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "1999",
            "value": 41.6
          },
          {
            "state": "North-East",
            "value": 12.7
          },
          {
            "state": "North-West",
            "value": 8.1
          },
          {
            "state": "South-East",
            "value": 65.3
          },
          {
            "state": "South-West",
            "value": 73.2
          },
          {
            "state": "North-Central",
            "value": 47.0
          }
        ]
      }
    },
    "2023": {
      "NDHS": {
        "states": [
          {
            "state": "Niger",
            "value": 33.7
          },
          {
            "state": "Plateau",
            "value": 50.1
          },
          {
            "state": "Adamawa",
            "value": 24.4
          },
          {
            "state": "Bauchi",
            "value": 28.4
          },
          {
            "state": "Borno",
            "value": 37.7
          },
          {
            "state": "Gombe",
            "value": 37.9
          },
          {
            "state": "Taraba",
            "value": 33.8
          },
          {
            "state": "Yobe",
            "value": 35.4
          },
          {
            "state": "Jigawa",
            "value": 24.6
          },
          {
            "state": "Kaduna",
            "value": 35.6
          },
          {
            "state": "Kano",
            "value": 36.3
          },
          {
            "state": "Katsina",
            "value": 19.1
          },
          {
            "state": "Kebbi",
            "value": 9.6
          },
          {
            "state": "Sokoto",
            "value": 12.4
          },
          {
            "state": "Zamfara",
            "value": 13.2
          },
          {
            "state": "Abia",
            "value": 95.2
          },
          {
            "state": "Anambra",
            "value": 91.8
          },
          {
            "state": "Ebonyi",
            "value": 73.6
          },
          {
            "state": "Imo",
            "value": 97.2
          },
          {
            "state": "Akwa Ibom",
            "value": 51.5
          },
          {
            "state": "Bayelsa",
            "value": 56.7
          },
          {
            "state": "Cross River",
            "value": 56.2
          },
          {
            "state": "Delta",
            "value": 81.4
          },
          {
            "state": "Edo",
            "value": 92.8
          },
          {
            "state": "Rivers",
            "value": 91.6
          },
          {
            "state": "Ekiti",
            "value": 93.5
          },
          {
            "state": "Lagos",
            "value": 86.6
          },
          {
            "state": "Ogun",
            "value": 82.6
          },
          {
            "state": "Ondo",
            "value": 76.3
          },
          {
            "state": "Osun",
            "value": 91.7
          },
          {
            "state": "Oyo",
            "value": 83.2
          },
          {
            "state": "FCT",
            "value": 82.4
          },
          {
            "state": "Benue",
            "value": 66.7
          },
          {
            "state": "Kogi",
            "value": 61.1
          },
          {
            "state": "Kwara",
            "value": 55.3
          },
          {
            "state": "Nasarawa",
            "value": 69.2
          },
          {
            "state": "Enugu",
            "value": 96.3
          }
        ],
        "national": [
          {
            "state": "South-East",
            "value": 88.1
          },
          {
            "state": "South-South",
            "value": 76.6
          },
          {
            "state": "South-West",
            "value": 84.9
          },
          {
            "state": "North-East",
            "value": 32.3
          },
          {
            "state": "2023",
            "value": 45.7
          },
          {
            "state": "North-Central",
            "value": 54.6
          },
          {
            "state": "North-West",
            "value": 25.6
          }
        ]
      }
    }
  },
  "postnatal_care_coverage": {
    "2013": {
      "NDHS": {
        "states": [
          {
            "state": "FCT",
            "value": 79.6
          },
          {
            "state": "Benue",
            "value": 39.4
          },
          {
            "state": "Kogi",
            "value": 71.2
          },
          {
            "state": "Kwara",
            "value": 63.7
          },
          {
            "state": "Nasarawa",
            "value": 49.4
          },
          {
            "state": "Niger",
            "value": 39.8
          },
          {
            "state": "Plateau",
            "value": 36.3
          },
          {
            "state": "Adamawa",
            "value": 34.0
          },
          {
            "state": "Bauchi",
            "value": 38.6
          },
          {
            "state": "Borno",
            "value": 20.1
          },
          {
            "state": "Gombe",
            "value": 32.8
          },
          {
            "state": "Taraba",
            "value": 34.5
          },
          {
            "state": "Yobe",
            "value": 29.4
          },
          {
            "state": "Jigawa",
            "value": 14.4
          },
          {
            "state": "Kaduna",
            "value": 50.4
          },
          {
            "state": "Kano",
            "value": 14.0
          },
          {
            "state": "Katsina",
            "value": 12.4
          },
          {
            "state": "Kebbi",
            "value": 7.6
          },
          {
            "state": "Sokoto",
            "value": 6.5
          },
          {
            "state": "Zamfara",
            "value": 18.7
          },
          {
            "state": "Abia",
            "value": 68.5
          },
          {
            "state": "Lagos",
            "value": 83.9
          },
          {
            "state": "Ogun",
            "value": 72.7
          },
          {
            "state": "Ondo",
            "value": 57.2
          },
          {
            "state": "Osun",
            "value": 87.4
          },
          {
            "state": "Oyo",
            "value": 64.1
          },
          {
            "state": "Akwa Ibom",
            "value": 64.7
          },
          {
            "state": "Bayelsa",
            "value": 55.8
          },
          {
            "state": "Cross River",
            "value": 68.3
          },
          {
            "state": "Delta",
            "value": 54.8
          },
          {
            "state": "Edo",
            "value": 76.5
          },
          {
            "state": "Rivers",
            "value": 47.1
          },
          {
            "state": "Ebonyi",
            "value": 55.3
          },
          {
            "state": "Enugu",
            "value": 68.6
          },
          {
            "state": "Imo",
            "value": 61.3
          },
          {
            "state": "Ekiti",
            "value": 55.0
          },
          {
            "state": "Anambra",
            "value": 56.1
          }
        ],
        "national": [
          {
            "state": "North-Central",
            "value": 47.6
          },
          {
            "state": "North-East",
            "value": 31.8
          },
          {
            "state": "North-West",
            "value": 17.0
          },
          {
            "state": "South-East",
            "value": 60.9
          },
          {
            "state": "South-West",
            "value": 72.7
          },
          {
            "state": "South-South",
            "value": 60.3
          },
          {
            "state": "2013",
            "value": 39.6
          }
        ]
      }
    },
    "2008": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "North-Central",
            "value": 35.0
          },
          {
            "state": "North-East",
            "value": 14.1
          },
          {
            "state": "North-West",
            "value": 9.6
          },
          {
            "state": "South-East",
            "value": 39.4
          },
          {
            "state": "South-South",
            "value": 41.2
          },
          {
            "state": "South-West",
            "value": 62.0
          },
          {
            "state": "2008",
            "value": 29.5
          }
        ]
      }
    },
    "2018": {
      "NDHS": {
        "states": [
          {
            "state": "Benue",
            "value": 51.4
          },
          {
            "state": "Kogi",
            "value": 73.5
          },
          {
            "state": "Kwara",
            "value": 58.3
          },
          {
            "state": "Nasarawa",
            "value": 43.0
          },
          {
            "state": "Niger",
            "value": 23.6
          },
          {
            "state": "Plateau",
            "value": 42.9
          },
          {
            "state": "Adamawa",
            "value": 51.4
          },
          {
            "state": "Bauchi",
            "value": 42.0
          },
          {
            "state": "Borno",
            "value": 31.2
          },
          {
            "state": "Gombe",
            "value": 33.0
          },
          {
            "state": "Taraba",
            "value": 25.1
          },
          {
            "state": "Yobe",
            "value": 18.3
          },
          {
            "state": "Kaduna",
            "value": 23.8
          },
          {
            "state": "Kano",
            "value": 23.2
          },
          {
            "state": "Katsina",
            "value": 16.5
          },
          {
            "state": "Sokoto",
            "value": 31.5
          },
          {
            "state": "Zamfara",
            "value": 13.4
          },
          {
            "state": "Abia",
            "value": 57.1
          },
          {
            "state": "Anambra",
            "value": 82.1
          },
          {
            "state": "Ebonyi",
            "value": 50.2
          },
          {
            "state": "Imo",
            "value": 82.1
          },
          {
            "state": "Akwa Ibom",
            "value": 61.3
          },
          {
            "state": "Bayelsa",
            "value": 26.5
          },
          {
            "state": "Cross River",
            "value": 42.9
          },
          {
            "state": "Delta",
            "value": 59.6
          },
          {
            "state": "Edo",
            "value": 72.2
          },
          {
            "state": "Rivers",
            "value": 43.8
          },
          {
            "state": "Oyo",
            "value": 81.2
          },
          {
            "state": "Ogun",
            "value": 77.7
          },
          {
            "state": "Lagos",
            "value": 72.8
          },
          {
            "state": "Ondo",
            "value": 75.0
          },
          {
            "state": "Osun",
            "value": 82.4
          },
          {
            "state": "Kebbi",
            "value": 17.6
          },
          {
            "state": "Ekiti",
            "value": 81.6
          },
          {
            "state": "FCT",
            "value": 60.9
          },
          {
            "state": "Jigawa",
            "value": 23.4
          },
          {
            "state": "Enugu",
            "value": 80.5
          }
        ],
        "national": [
          {
            "state": "2018",
            "value": 41.8
          },
          {
            "state": "North-Central",
            "value": 44.5
          },
          {
            "state": "North-West",
            "value": 21.1
          },
          {
            "state": "South-East",
            "value": 71.6
          },
          {
            "state": "South-West",
            "value": 77.3
          },
          {
            "state": "South-South",
            "value": 55.2
          },
          {
            "state": "North-East",
            "value": 33.7
          }
        ]
      }
    },
    "2003": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "2003",
            "value": 49.6
          }
        ]
      }
    },
    "2023": {
      "NDHS": {
        "states": [
          {
            "state": "FCT",
            "value": 82.3
          },
          {
            "state": "Benue",
            "value": 56.2
          },
          {
            "state": "Kogi",
            "value": 55.8
          },
          {
            "state": "Kwara",
            "value": 57.0
          },
          {
            "state": "Nasarawa",
            "value": 68.4
          },
          {
            "state": "Niger",
            "value": 32.6
          },
          {
            "state": "Plateau",
            "value": 56.3
          },
          {
            "state": "Adamawa",
            "value": 50.6
          },
          {
            "state": "Bauchi",
            "value": 23.9
          },
          {
            "state": "Borno",
            "value": 47.5
          },
          {
            "state": "Gombe",
            "value": 44.9
          },
          {
            "state": "Taraba",
            "value": 34.4
          },
          {
            "state": "Yobe",
            "value": 33.9
          },
          {
            "state": "Jigawa",
            "value": 43.9
          },
          {
            "state": "Kaduna",
            "value": 22.5
          },
          {
            "state": "Kano",
            "value": 32.8
          },
          {
            "state": "Katsina",
            "value": 19.4
          },
          {
            "state": "Kebbi",
            "value": 11.3
          },
          {
            "state": "Sokoto",
            "value": 11.6
          },
          {
            "state": "Zamfara",
            "value": 18.1
          },
          {
            "state": "Abia",
            "value": 66.4
          },
          {
            "state": "Anambra",
            "value": 73.2
          },
          {
            "state": "Ebonyi",
            "value": 55.9
          },
          {
            "state": "Enugu",
            "value": 65.8
          },
          {
            "state": "Imo",
            "value": 61.7
          },
          {
            "state": "Akwa Ibom",
            "value": 60.4
          },
          {
            "state": "Bayelsa",
            "value": 43.4
          },
          {
            "state": "Cross River",
            "value": 74.6
          },
          {
            "state": "Delta",
            "value": 76.2
          },
          {
            "state": "Edo",
            "value": 86.1
          },
          {
            "state": "Rivers",
            "value": 54.3
          },
          {
            "state": "Ekiti",
            "value": 77.5
          },
          {
            "state": "Lagos",
            "value": 87.3
          },
          {
            "state": "Ogun",
            "value": 81.0
          },
          {
            "state": "Ondo",
            "value": 75.9
          },
          {
            "state": "Osun",
            "value": 75.3
          },
          {
            "state": "Oyo",
            "value": 68.3
          }
        ],
        "national": [
          {
            "state": "2023",
            "value": 42.9
          },
          {
            "state": "North-Central",
            "value": 53.4
          },
          {
            "state": "North-East",
            "value": 36.3
          },
          {
            "state": "North-West",
            "value": 24.9
          },
          {
            "state": "South-East",
            "value": 63.1
          },
          {
            "state": "South-South",
            "value": 66.5
          },
          {
            "state": "South-West",
            "value": 78.5
          }
        ]
      }
    }
  },
  "penta_3_coverage": {
    "2003": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "South-West",
            "value": 67.8
          },
          {
            "state": "North-Central",
            "value": 23.8
          },
          {
            "state": "North-East",
            "value": 9.1
          },
          {
            "state": "North-West",
            "value": 5.8
          },
          {
            "state": "South-East",
            "value": 58.5
          },
          {
            "state": "South-South",
            "value": 32.5
          },
          {
            "state": "2003",
            "value": 21.4
          }
        ]
      }
    },
    "2008": {
      "NDHS": {
        "states": [
          {
            "state": "FCT",
            "value": 75.9
          },
          {
            "state": "Benue",
            "value": 36.8
          },
          {
            "state": "Kogi",
            "value": 55.0
          },
          {
            "state": "Kwara",
            "value": 55.2
          },
          {
            "state": "Nasarawa",
            "value": 30.1
          },
          {
            "state": "Niger",
            "value": 20.9
          },
          {
            "state": "Plateau",
            "value": 56.8
          },
          {
            "state": "Adamawa",
            "value": 30.2
          },
          {
            "state": "Borno",
            "value": 2.5
          },
          {
            "state": "Gombe",
            "value": 28.2
          },
          {
            "state": "Taraba",
            "value": 19.6
          },
          {
            "state": "Yobe",
            "value": 9.1
          },
          {
            "state": "Jigawa",
            "value": 0.0
          },
          {
            "state": "Kaduna",
            "value": 32.7
          },
          {
            "state": "Kano",
            "value": 7.6
          },
          {
            "state": "Katsina",
            "value": 1.7
          },
          {
            "state": "Kebbi",
            "value": 7.2
          },
          {
            "state": "Sokoto",
            "value": 2.0
          },
          {
            "state": "Zamfara",
            "value": 8.8
          },
          {
            "state": "Abia",
            "value": 59.8
          },
          {
            "state": "Anambra",
            "value": 76.3
          },
          {
            "state": "Ebonyi",
            "value": 60.1
          },
          {
            "state": "Enugu",
            "value": 50.0
          },
          {
            "state": "Imo",
            "value": 77.0
          },
          {
            "state": "Akwa Ibom",
            "value": 51.5
          },
          {
            "state": "Bayelsa",
            "value": 27.6
          },
          {
            "state": "Cross River",
            "value": 64.6
          },
          {
            "state": "Delta",
            "value": 58.1
          },
          {
            "state": "Edo",
            "value": 61.8
          },
          {
            "state": "Rivers",
            "value": 51.8
          },
          {
            "state": "Ekiti",
            "value": 88.5
          },
          {
            "state": "Lagos",
            "value": 73.6
          },
          {
            "state": "Ogun",
            "value": 42.0
          },
          {
            "state": "Ondo",
            "value": 54.3
          },
          {
            "state": "Osun",
            "value": 85.6
          },
          {
            "state": "Oyo",
            "value": 60.7
          },
          {
            "state": "Bauchi",
            "value": 1.0
          }
        ],
        "national": [
          {
            "state": "2008",
            "value": 35.4
          },
          {
            "state": "North-East",
            "value": 12.4
          },
          {
            "state": "North-West",
            "value": 9.1
          },
          {
            "state": "South-East",
            "value": 66.9
          },
          {
            "state": "South-West",
            "value": 66.5
          },
          {
            "state": "South-South",
            "value": 54.2
          },
          {
            "state": "North-Central",
            "value": 43.4
          }
        ]
      }
    },
    "2013": {
      "NDHS": {
        "states": [
          {
            "state": "Kwara",
            "value": 65.1
          },
          {
            "state": "Nasarawa",
            "value": 34.1
          },
          {
            "state": "Niger",
            "value": 37.3
          },
          {
            "state": "Plateau",
            "value": 46.3
          },
          {
            "state": "Adamawa",
            "value": 49.7
          },
          {
            "state": "Bauchi",
            "value": 12.5
          },
          {
            "state": "Borno",
            "value": 12.4
          },
          {
            "state": "Gombe",
            "value": 36.0
          },
          {
            "state": "Taraba",
            "value": 21.4
          },
          {
            "state": "Yobe",
            "value": 11.0
          },
          {
            "state": "Jigawa",
            "value": 7.0
          },
          {
            "state": "Kaduna",
            "value": 43.7
          },
          {
            "state": "Kano",
            "value": 18.9
          },
          {
            "state": "Katsina",
            "value": 14.6
          },
          {
            "state": "Kebbi",
            "value": 2.8
          },
          {
            "state": "Sokoto",
            "value": 2.6
          },
          {
            "state": "Zamfara",
            "value": 5.6
          },
          {
            "state": "Abia",
            "value": 79.8
          },
          {
            "state": "Anambra",
            "value": 78.5
          },
          {
            "state": "Ebonyi",
            "value": 80.3
          },
          {
            "state": "Enugu",
            "value": 81.8
          },
          {
            "state": "Akwa Ibom",
            "value": 65.3
          },
          {
            "state": "Bayelsa",
            "value": 67.7
          },
          {
            "state": "Cross River",
            "value": 76.1
          },
          {
            "state": "Delta",
            "value": 62.2
          },
          {
            "state": "Edo",
            "value": 79.6
          },
          {
            "state": "Rivers",
            "value": 69.2
          },
          {
            "state": "Ekiti",
            "value": 79.0
          },
          {
            "state": "Lagos",
            "value": 77.4
          },
          {
            "state": "Ogun",
            "value": 56.9
          },
          {
            "state": "Ondo",
            "value": 62.5
          },
          {
            "state": "Osun",
            "value": 82.8
          },
          {
            "state": "Oyo",
            "value": 47.7
          },
          {
            "state": "FCT",
            "value": 69.1
          },
          {
            "state": "Benue",
            "value": 29.0
          },
          {
            "state": "Kogi",
            "value": 75.9
          },
          {
            "state": "Imo",
            "value": 83.1
          }
        ],
        "national": [
          {
            "state": "North-Central",
            "value": 43.9
          },
          {
            "state": "North-East",
            "value": 20.6
          },
          {
            "state": "North-West",
            "value": 13.9
          },
          {
            "state": "South-East",
            "value": 80.7
          },
          {
            "state": "South-West",
            "value": 65.5
          },
          {
            "state": "2013",
            "value": 38.2
          },
          {
            "state": "South-South",
            "value": 69.8
          }
        ]
      }
    },
    "2018": {
      "NDHS": {
        "states": [
          {
            "state": "Abia",
            "value": 80.4
          },
          {
            "state": "Adamawa",
            "value": 65.9
          },
          {
            "state": "Akwa Ibom",
            "value": 70.8
          },
          {
            "state": "Anambra",
            "value": 87.3
          },
          {
            "state": "Bauchi",
            "value": 32.1
          },
          {
            "state": "Bayelsa",
            "value": 54.5
          },
          {
            "state": "Benue",
            "value": 58.7
          },
          {
            "state": "Borno",
            "value": 36.0
          },
          {
            "state": "Cross River",
            "value": 81.8
          },
          {
            "state": "Delta",
            "value": 71.7
          },
          {
            "state": "Ebonyi",
            "value": 82.4
          },
          {
            "state": "Edo",
            "value": 80.7
          },
          {
            "state": "Ekiti",
            "value": 93.0
          },
          {
            "state": "Kano",
            "value": 45.9
          },
          {
            "state": "Katsina",
            "value": 33.7
          },
          {
            "state": "Kebbi",
            "value": 10.6
          },
          {
            "state": "Kogi",
            "value": 55.6
          },
          {
            "state": "Kwara",
            "value": 54.5
          },
          {
            "state": "Lagos",
            "value": 90.8
          },
          {
            "state": "Niger",
            "value": 38.8
          },
          {
            "state": "Ogun",
            "value": 50.3
          },
          {
            "state": "Ondo",
            "value": 77.0
          },
          {
            "state": "Osun",
            "value": 83.5
          },
          {
            "state": "Oyo",
            "value": 44.3
          },
          {
            "state": "Plateau",
            "value": 71.8
          },
          {
            "state": "Rivers",
            "value": 74.5
          },
          {
            "state": "Sokoto",
            "value": 7.2
          },
          {
            "state": "Taraba",
            "value": 41.7
          },
          {
            "state": "Yobe",
            "value": 29.0
          },
          {
            "state": "Zamfara",
            "value": 10.8
          },
          {
            "state": "FCT",
            "value": 73.5
          },
          {
            "state": "Enugu",
            "value": 80.9
          },
          {
            "state": "Gombe",
            "value": 25.8
          },
          {
            "state": "Imo",
            "value": 79.5
          },
          {
            "state": "Jigawa",
            "value": 35.7
          },
          {
            "state": "Kaduna",
            "value": 31.9
          },
          {
            "state": "Nasarawa",
            "value": 59.7
          }
        ],
        "national": [
          {
            "state": "South-West",
            "value": 73.8
          },
          {
            "state": "2018",
            "value": 50.1
          },
          {
            "state": "North-Central",
            "value": 54.4
          },
          {
            "state": "North-East",
            "value": 37.2
          },
          {
            "state": "North-West",
            "value": 29.1
          },
          {
            "state": "South-East",
            "value": 83.1
          },
          {
            "state": "South-South",
            "value": 69.6
          }
        ]
      }
    },
    "1999": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "1999",
            "value": 26.3
          }
        ]
      }
    },
    "1990": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "North-East",
            "value": 16.9
          },
          {
            "state": "North-West",
            "value": 18.7
          },
          {
            "state": "South-East",
            "value": 49.8
          },
          {
            "state": "South-West",
            "value": 50.0
          },
          {
            "state": "1990",
            "value": 32.9
          }
        ]
      }
    },
    "2023": {
      "NDHS": {
        "states": [
          {
            "state": "FCT",
            "value": 84.8
          },
          {
            "state": "Benue",
            "value": 44.3
          },
          {
            "state": "Kogi",
            "value": 37.1
          },
          {
            "state": "Kwara",
            "value": 34.9
          },
          {
            "state": "Niger",
            "value": 36.7
          },
          {
            "state": "Plateau",
            "value": 47.1
          },
          {
            "state": "Adamawa",
            "value": 59.2
          },
          {
            "state": "Bauchi",
            "value": 58.2
          },
          {
            "state": "Borno",
            "value": 42.2
          },
          {
            "state": "Gombe",
            "value": 59.8
          },
          {
            "state": "Taraba",
            "value": 47.3
          },
          {
            "state": "Yobe",
            "value": 51.3
          },
          {
            "state": "Jigawa",
            "value": 62.2
          },
          {
            "state": "Kaduna",
            "value": 48.0
          },
          {
            "state": "Kano",
            "value": 47.5
          },
          {
            "state": "Katsina",
            "value": 53.3
          },
          {
            "state": "Kebbi",
            "value": 13.1
          },
          {
            "state": "Sokoto",
            "value": 10.9
          },
          {
            "state": "Zamfara",
            "value": 12.6
          },
          {
            "state": "Abia",
            "value": 79.7
          },
          {
            "state": "Anambra",
            "value": 78.6
          },
          {
            "state": "Ebonyi",
            "value": 75.9
          },
          {
            "state": "Imo",
            "value": 83.4
          },
          {
            "state": "Akwa Ibom",
            "value": 72.8
          },
          {
            "state": "Bayelsa",
            "value": 73.4
          },
          {
            "state": "Cross River",
            "value": 94.6
          },
          {
            "state": "Delta",
            "value": 85.7
          },
          {
            "state": "Edo",
            "value": 84.5
          },
          {
            "state": "Rivers",
            "value": 71.0
          },
          {
            "state": "Ekiti",
            "value": 75.9
          },
          {
            "state": "Lagos",
            "value": 87.6
          },
          {
            "state": "Ogun",
            "value": 73.9
          },
          {
            "state": "Ondo",
            "value": 63.9
          },
          {
            "state": "Osun",
            "value": 67.1
          },
          {
            "state": "Enugu",
            "value": 81.6
          },
          {
            "state": "Nasarawa",
            "value": 67.1
          },
          {
            "state": "Oyo",
            "value": 52.6
          }
        ],
        "national": [
          {
            "state": "South-South",
            "value": 79.6
          },
          {
            "state": "South-West",
            "value": 72.8
          },
          {
            "state": "2023",
            "value": 53.4
          },
          {
            "state": "North-Central",
            "value": 48.2
          },
          {
            "state": "North-East",
            "value": 53.0
          },
          {
            "state": "North-West",
            "value": 39.7
          },
          {
            "state": "South-East",
            "value": 79.3
          }
        ]
      }
    }
  },
  "full_immunization_rate": {
    "2013": {
      "NDHS": {
        "states": [
          {
            "state": "FCT",
            "value": 60.9
          },
          {
            "state": "Benue",
            "value": 20.0
          },
          {
            "state": "Kogi",
            "value": 35.6
          },
          {
            "state": "Kwara",
            "value": 42.9
          },
          {
            "state": "Nasarawa",
            "value": 20.1
          },
          {
            "state": "Niger",
            "value": 23.0
          },
          {
            "state": "Plateau",
            "value": 23.6
          },
          {
            "state": "Adamawa",
            "value": 40.4
          },
          {
            "state": "Bauchi",
            "value": 6.1
          },
          {
            "state": "Borno",
            "value": 9.7
          },
          {
            "state": "Gombe",
            "value": 22.4
          },
          {
            "state": "Taraba",
            "value": 14.4
          },
          {
            "state": "Yobe",
            "value": 6.9
          },
          {
            "state": "Jigawa",
            "value": 3.6
          },
          {
            "state": "Kaduna",
            "value": 35.3
          },
          {
            "state": "Kano",
            "value": 13.2
          },
          {
            "state": "Katsina",
            "value": 8.7
          },
          {
            "state": "Kebbi",
            "value": 2.8
          },
          {
            "state": "Sokoto",
            "value": 1.4
          },
          {
            "state": "Imo",
            "value": 62.4
          },
          {
            "state": "Ekiti",
            "value": 49.4
          },
          {
            "state": "Lagos",
            "value": 53.9
          },
          {
            "state": "Ogun",
            "value": 24.4
          },
          {
            "state": "Ondo",
            "value": 47.2
          },
          {
            "state": "Osun",
            "value": 55.3
          },
          {
            "state": "Oyo",
            "value": 25.8
          },
          {
            "state": "Akwa Ibom",
            "value": 48.0
          },
          {
            "state": "Bayelsa",
            "value": 51.5
          },
          {
            "state": "Cross River",
            "value": 52.5
          },
          {
            "state": "Delta",
            "value": 50.7
          },
          {
            "state": "Edo",
            "value": 52.2
          },
          {
            "state": "Rivers",
            "value": 55.5
          },
          {
            "state": "Abia",
            "value": 49.8
          },
          {
            "state": "Anambra",
            "value": 51.6
          },
          {
            "state": "Ebonyi",
            "value": 51.1
          },
          {
            "state": "Enugu",
            "value": 45.0
          },
          {
            "state": "Zamfara",
            "value": 2.1
          }
        ],
        "national": [
          {
            "state": "North-Central",
            "value": 26.9
          },
          {
            "state": "North-East",
            "value": 14.2
          },
          {
            "state": "North-West",
            "value": 9.6
          },
          {
            "state": "South-East",
            "value": 51.7
          },
          {
            "state": "South-West",
            "value": 40.9
          },
          {
            "state": "South-South",
            "value": 52.0
          },
          {
            "state": "2013",
            "value": 25.3
          }
        ]
      }
    },
    "2008": {
      "NDHS": {
        "states": [
          {
            "state": "Abia",
            "value": 38.9
          },
          {
            "state": "Adamawa",
            "value": 19.1
          },
          {
            "state": "Akwa Ibom",
            "value": 32.4
          },
          {
            "state": "Anambra",
            "value": 51.9
          },
          {
            "state": "Bauchi",
            "value": 1.0
          },
          {
            "state": "Bayelsa",
            "value": 20.4
          },
          {
            "state": "Benue",
            "value": 18.8
          },
          {
            "state": "Borno",
            "value": 1.5
          },
          {
            "state": "Cross River",
            "value": 42.1
          },
          {
            "state": "Delta",
            "value": 38.4
          },
          {
            "state": "Ebonyi",
            "value": 50.0
          },
          {
            "state": "Edo",
            "value": 38.8
          },
          {
            "state": "Ekiti",
            "value": 57.7
          },
          {
            "state": "Enugu",
            "value": 28.4
          },
          {
            "state": "Gombe",
            "value": 15.5
          },
          {
            "state": "Imo",
            "value": 40.3
          },
          {
            "state": "Jigawa",
            "value": 0.0
          },
          {
            "state": "Kaduna",
            "value": 21.4
          },
          {
            "state": "Kano",
            "value": 5.5
          },
          {
            "state": "Katsina",
            "value": 0.9
          },
          {
            "state": "Kebbi",
            "value": 4.8
          },
          {
            "state": "Kogi",
            "value": 39.3
          },
          {
            "state": "Kwara",
            "value": 30.9
          },
          {
            "state": "Lagos",
            "value": 52.8
          },
          {
            "state": "Nasarawa",
            "value": 16.1
          },
          {
            "state": "Niger",
            "value": 12.3
          },
          {
            "state": "Ogun",
            "value": 23.1
          },
          {
            "state": "Ondo",
            "value": 37.0
          },
          {
            "state": "Osun",
            "value": 58.7
          },
          {
            "state": "Oyo",
            "value": 30.6
          },
          {
            "state": "Plateau",
            "value": 31.2
          },
          {
            "state": "Rivers",
            "value": 36.5
          },
          {
            "state": "Sokoto",
            "value": 1.0
          },
          {
            "state": "Taraba",
            "value": 14.1
          },
          {
            "state": "Yobe",
            "value": 4.0
          },
          {
            "state": "Zamfara",
            "value": 5.4
          },
          {
            "state": "FCT",
            "value": 55.4
          }
        ],
        "national": [
          {
            "state": "South-South",
            "value": 36.0
          },
          {
            "state": "2008",
            "value": 22.7
          },
          {
            "state": "North-Central",
            "value": 25.9
          },
          {
            "state": "North-East",
            "value": 7.6
          },
          {
            "state": "North-West",
            "value": 6.0
          },
          {
            "state": "South-East",
            "value": 42.9
          },
          {
            "state": "South-West",
            "value": 42.8
          }
        ]
      }
    },
    "2003": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "North-Central",
            "value": 12.4
          },
          {
            "state": "North-East",
            "value": 6.0
          },
          {
            "state": "South-East",
            "value": 44.6
          },
          {
            "state": "South-West",
            "value": 32.5
          },
          {
            "state": "South-South",
            "value": 20.8
          },
          {
            "state": "2003",
            "value": 12.9
          },
          {
            "state": "North-West",
            "value": 3.7
          }
        ]
      }
    },
    "1999": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "1999",
            "value": 16.8
          }
        ]
      }
    },
    "2018": {
      "NDHS": {
        "states": [
          {
            "state": "Abia",
            "value": 28.9
          },
          {
            "state": "Adamawa",
            "value": 16.3
          },
          {
            "state": "Bauchi",
            "value": 11.7
          },
          {
            "state": "Bayelsa",
            "value": 12.4
          },
          {
            "state": "Benue",
            "value": 18.6
          },
          {
            "state": "Borno",
            "value": 13.5
          },
          {
            "state": "Delta",
            "value": 30.0
          },
          {
            "state": "Edo",
            "value": 48.2
          },
          {
            "state": "Ekiti",
            "value": 26.8
          },
          {
            "state": "Enugu",
            "value": 19.9
          },
          {
            "state": "Gombe",
            "value": 6.1
          },
          {
            "state": "Imo",
            "value": 51.3
          },
          {
            "state": "Jigawa",
            "value": 16.2
          },
          {
            "state": "Kaduna",
            "value": 13.8
          },
          {
            "state": "Kano",
            "value": 19.4
          },
          {
            "state": "Katsina",
            "value": 10.6
          },
          {
            "state": "Kebbi",
            "value": 1.1
          },
          {
            "state": "Kogi",
            "value": 8.1
          },
          {
            "state": "Kwara",
            "value": 26.0
          },
          {
            "state": "Lagos",
            "value": 56.2
          },
          {
            "state": "Nasarawa",
            "value": 29.5
          },
          {
            "state": "Niger",
            "value": 12.3
          },
          {
            "state": "Ogun",
            "value": 20.9
          },
          {
            "state": "Ondo",
            "value": 39.7
          },
          {
            "state": "Osun",
            "value": 17.2
          },
          {
            "state": "Oyo",
            "value": 16.6
          },
          {
            "state": "Plateau",
            "value": 28.8
          },
          {
            "state": "Rivers",
            "value": 28.5
          },
          {
            "state": "Sokoto",
            "value": 1.2
          },
          {
            "state": "Taraba",
            "value": 12.8
          },
          {
            "state": "Yobe",
            "value": 12.9
          },
          {
            "state": "Zamfara",
            "value": 4.0
          },
          {
            "state": "FCT",
            "value": 40.1
          },
          {
            "state": "Cross River",
            "value": 21.8
          },
          {
            "state": "Akwa Ibom",
            "value": 28.3
          },
          {
            "state": "Anambra",
            "value": 60.4
          },
          {
            "state": "Ebonyi",
            "value": 26.3
          }
        ],
        "national": [
          {
            "state": "South-West",
            "value": 34.9
          },
          {
            "state": "North-Central",
            "value": 20.0
          },
          {
            "state": "North-East",
            "value": 12.4
          },
          {
            "state": "North-West",
            "value": 11.3
          },
          {
            "state": "South-East",
            "value": 42.0
          },
          {
            "state": "South-South",
            "value": 29.3
          },
          {
            "state": "2018",
            "value": 31.3
          }
        ]
      }
    },
    "1990": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "North-West",
            "value": 17.7
          },
          {
            "state": "North-East",
            "value": 15.5
          },
          {
            "state": "South-East",
            "value": 42.4
          },
          {
            "state": "South-West",
            "value": 43.9
          },
          {
            "state": "1990",
            "value": 29.0
          }
        ]
      }
    },
    "2023": {
      "NDHS": {
        "states": [
          {
            "state": "FCT",
            "value": 45.6
          },
          {
            "state": "Benue",
            "value": 25.4
          },
          {
            "state": "Kogi",
            "value": 16.8
          },
          {
            "state": "Kwara",
            "value": 28.1
          },
          {
            "state": "Nasarawa",
            "value": 42.3
          },
          {
            "state": "Niger",
            "value": 28.3
          },
          {
            "state": "Plateau",
            "value": 25.3
          },
          {
            "state": "Adamawa",
            "value": 38.4
          },
          {
            "state": "Bauchi",
            "value": 51.4
          },
          {
            "state": "Borno",
            "value": 28.5
          },
          {
            "state": "Gombe",
            "value": 49.2
          },
          {
            "state": "Taraba",
            "value": 26.0
          },
          {
            "state": "Yobe",
            "value": 37.4
          },
          {
            "state": "Jigawa",
            "value": 56.9
          },
          {
            "state": "Kaduna",
            "value": 35.7
          },
          {
            "state": "Kano",
            "value": 35.8
          },
          {
            "state": "Katsina",
            "value": 45.3
          },
          {
            "state": "Kebbi",
            "value": 9.7
          },
          {
            "state": "Sokoto",
            "value": 8.4
          },
          {
            "state": "Zamfara",
            "value": 9.6
          },
          {
            "state": "Abia",
            "value": 38.0
          },
          {
            "state": "Anambra",
            "value": 48.7
          },
          {
            "state": "Ebonyi",
            "value": 57.9
          },
          {
            "state": "Enugu",
            "value": 51.8
          },
          {
            "state": "Imo",
            "value": 59.1
          },
          {
            "state": "Akwa Ibom",
            "value": 50.8
          },
          {
            "state": "Cross River",
            "value": 68.6
          },
          {
            "state": "Delta",
            "value": 68.1
          },
          {
            "state": "Edo",
            "value": 58.4
          },
          {
            "state": "Rivers",
            "value": 55.7
          },
          {
            "state": "Ekiti",
            "value": 56.6
          },
          {
            "state": "Ogun",
            "value": 51.4
          },
          {
            "state": "Ondo",
            "value": 50.9
          },
          {
            "state": "Osun",
            "value": 55.3
          },
          {
            "state": "Oyo",
            "value": 31.1
          },
          {
            "state": "Bayelsa",
            "value": 63.4
          },
          {
            "state": "Lagos",
            "value": 66.1
          }
        ],
        "national": [
          {
            "state": "North-Central",
            "value": 30.1
          },
          {
            "state": "North-West",
            "value": 31.6
          },
          {
            "state": "South-East",
            "value": 53.5
          },
          {
            "state": "South-South",
            "value": 60.7
          },
          {
            "state": "South-West",
            "value": 52.9
          },
          {
            "state": "North-East",
            "value": 40.2
          },
          {
            "state": "2023",
            "value": 39.4
          }
        ]
      }
    }
  },
  "maternal_mortality_ratio_trend": {
    "2018": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "2018",
            "value": 512.0
          }
        ]
      }
    },
    "2008": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "2008",
            "value": 545.0
          }
        ]
      }
    },
    "2013": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "2013",
            "value": 576.0
          }
        ]
      }
    }
  },
  "infant_mortality_rate": {
    "2008": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "South-South",
            "value": 84.0
          },
          {
            "state": "South-West",
            "value": 59.0
          },
          {
            "state": "North-West",
            "value": 91.0
          },
          {
            "state": "2008",
            "value": 75.0
          },
          {
            "state": "North-Central",
            "value": 77.0
          },
          {
            "state": "North-East",
            "value": 109.0
          },
          {
            "state": "South-East",
            "value": 95.0
          }
        ]
      }
    },
    "2013": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "2013",
            "value": 69.0
          },
          {
            "state": "North-Central",
            "value": 66.0
          },
          {
            "state": "North-East",
            "value": 77.0
          },
          {
            "state": "North-West",
            "value": 89.0
          },
          {
            "state": "South-East",
            "value": 82.0
          },
          {
            "state": "South-South",
            "value": 58.0
          },
          {
            "state": "South-West",
            "value": 61.0
          }
        ]
      }
    },
    "1999": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "1999",
            "value": 75.2
          }
        ]
      }
    },
    "2003": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "2003",
            "value": 100.0
          }
        ]
      }
    },
    "1990": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "North-East",
            "value": 87.7
          },
          {
            "state": "North-West",
            "value": 109.8
          },
          {
            "state": "South-East",
            "value": 82.7
          },
          {
            "state": "South-West",
            "value": 84.6
          },
          {
            "state": "1990",
            "value": 87.0
          }
        ]
      }
    },
    "2018": {
      "NDHS": {
        "states": [
          {
            "state": "Abia",
            "value": 65.0
          },
          {
            "state": "Adamawa",
            "value": 68.0
          },
          {
            "state": "Akwa Ibom",
            "value": 70.0
          },
          {
            "state": "Anambra",
            "value": 35.0
          },
          {
            "state": "Bauchi",
            "value": 69.0
          },
          {
            "state": "Benue",
            "value": 40.0
          },
          {
            "state": "Borno",
            "value": 52.0
          },
          {
            "state": "Cross River",
            "value": 60.0
          },
          {
            "state": "Ebonyi",
            "value": 57.0
          },
          {
            "state": "Edo",
            "value": 52.0
          },
          {
            "state": "Ekiti",
            "value": 57.0
          },
          {
            "state": "Enugu",
            "value": 40.0
          },
          {
            "state": "FCT",
            "value": 46.0
          },
          {
            "state": "Gombe",
            "value": 104.0
          },
          {
            "state": "Imo",
            "value": 54.0
          },
          {
            "state": "Jigawa",
            "value": 81.0
          },
          {
            "state": "Kaduna",
            "value": 97.0
          },
          {
            "state": "Kano",
            "value": 62.0
          },
          {
            "state": "Niger",
            "value": 57.0
          },
          {
            "state": "Ogun",
            "value": 19.0
          },
          {
            "state": "Ondo",
            "value": 49.0
          },
          {
            "state": "Osun",
            "value": 47.0
          },
          {
            "state": "Oyo",
            "value": 41.0
          },
          {
            "state": "Plateau",
            "value": 65.0
          },
          {
            "state": "Rivers",
            "value": 48.0
          },
          {
            "state": "Sokoto",
            "value": 102.0
          },
          {
            "state": "Taraba",
            "value": 63.0
          },
          {
            "state": "Yobe",
            "value": 90.0
          },
          {
            "state": "Zamfara",
            "value": 66.0
          },
          {
            "state": "Kebbi",
            "value": 112.0
          },
          {
            "state": "Kwara",
            "value": 52.0
          },
          {
            "state": "Lagos",
            "value": 47.0
          },
          {
            "state": "Nasarawa",
            "value": 64.0
          },
          {
            "state": "Delta",
            "value": 32.0
          },
          {
            "state": "Kogi",
            "value": 93.0
          },
          {
            "state": "Katsina",
            "value": 66.0
          },
          {
            "state": "Bayelsa",
            "value": 23.0
          }
        ],
        "national": [
          {
            "state": "North-East",
            "value": 73.0
          },
          {
            "state": "North-West",
            "value": 80.0
          },
          {
            "state": "South-East",
            "value": 48.0
          },
          {
            "state": "South-South",
            "value": 49.0
          },
          {
            "state": "South-West",
            "value": 43.0
          },
          {
            "state": "2018",
            "value": 67.0
          },
          {
            "state": "North-Central",
            "value": 58.0
          }
        ]
      }
    },
    "2023": {
      "NDHS": {
        "states": [
          {
            "state": "FCT",
            "value": 35.0
          },
          {
            "state": "Benue",
            "value": 34.0
          },
          {
            "state": "Kogi",
            "value": 59.0
          },
          {
            "state": "Kwara",
            "value": 12.0
          },
          {
            "state": "Nasarawa",
            "value": 70.0
          },
          {
            "state": "Niger",
            "value": 31.0
          },
          {
            "state": "Plateau",
            "value": 59.0
          },
          {
            "state": "Adamawa",
            "value": 75.0
          },
          {
            "state": "Bauchi",
            "value": 77.0
          },
          {
            "state": "Borno",
            "value": 48.0
          },
          {
            "state": "Gombe",
            "value": 81.0
          },
          {
            "state": "Taraba",
            "value": 64.0
          },
          {
            "state": "Jigawa",
            "value": 81.0
          },
          {
            "state": "Kaduna",
            "value": 85.0
          },
          {
            "state": "Kano",
            "value": 86.0
          },
          {
            "state": "Anambra",
            "value": 50.0
          },
          {
            "state": "Ebonyi",
            "value": 42.0
          },
          {
            "state": "Enugu",
            "value": 34.0
          },
          {
            "state": "Imo",
            "value": 62.0
          },
          {
            "state": "Akwa Ibom",
            "value": 56.0
          },
          {
            "state": "Bayelsa",
            "value": 56.0
          },
          {
            "state": "Cross River",
            "value": 39.0
          },
          {
            "state": "Delta",
            "value": 26.0
          },
          {
            "state": "Edo",
            "value": 13.0
          },
          {
            "state": "Rivers",
            "value": 39.0
          },
          {
            "state": "Ekiti",
            "value": 27.0
          },
          {
            "state": "Lagos",
            "value": 36.0
          },
          {
            "state": "Ogun",
            "value": 47.0
          },
          {
            "state": "Ondo",
            "value": 8.0
          },
          {
            "state": "Osun",
            "value": 49.0
          },
          {
            "state": "Oyo",
            "value": 18.0
          },
          {
            "state": "Sokoto",
            "value": 56.0
          },
          {
            "state": "Zamfara",
            "value": 60.0
          },
          {
            "state": "Abia",
            "value": 49.0
          },
          {
            "state": "Katsina",
            "value": 63.0
          },
          {
            "state": "Yobe",
            "value": 54.0
          },
          {
            "state": "Kebbi",
            "value": 90.0
          }
        ],
        "national": [
          {
            "state": "North-East",
            "value": 66.0
          },
          {
            "state": "North-West",
            "value": 76.0
          },
          {
            "state": "South-East",
            "value": 48.0
          },
          {
            "state": "North-Central",
            "value": 42.0
          },
          {
            "state": "South-South",
            "value": 36.0
          },
          {
            "state": "South-West",
            "value": 33.0
          },
          {
            "state": "2023",
            "value": 63.0
          }
        ]
      }
    }
  },
  "under_five_mortality_rate": {
    "2018": {
      "NDHS": {
        "states": [
          {
            "state": "Bayelsa",
            "value": 31.0
          },
          {
            "state": "Abia",
            "value": 86.0
          },
          {
            "state": "Adamawa",
            "value": 104.0
          },
          {
            "state": "Akwa Ibom",
            "value": 98.0
          },
          {
            "state": "Anambra",
            "value": 58.0
          },
          {
            "state": "Bauchi",
            "value": 147.0
          },
          {
            "state": "Benue",
            "value": 59.0
          },
          {
            "state": "Borno",
            "value": 86.0
          },
          {
            "state": "Cross River",
            "value": 80.0
          },
          {
            "state": "Delta",
            "value": 53.0
          },
          {
            "state": "Ebonyi",
            "value": 91.0
          },
          {
            "state": "Edo",
            "value": 71.0
          },
          {
            "state": "Ekiti",
            "value": 95.0
          },
          {
            "state": "Enugu",
            "value": 61.0
          },
          {
            "state": "FCT",
            "value": 75.0
          },
          {
            "state": "Gombe",
            "value": 189.0
          },
          {
            "state": "Imo",
            "value": 87.0
          },
          {
            "state": "Jigawa",
            "value": 213.0
          },
          {
            "state": "Kwara",
            "value": 74.0
          },
          {
            "state": "Lagos",
            "value": 59.0
          },
          {
            "state": "Niger",
            "value": 98.0
          },
          {
            "state": "Ogun",
            "value": 30.0
          },
          {
            "state": "Ondo",
            "value": 79.0
          },
          {
            "state": "Osun",
            "value": 70.0
          },
          {
            "state": "Oyo",
            "value": 64.0
          },
          {
            "state": "Plateau",
            "value": 106.0
          },
          {
            "state": "Rivers",
            "value": 79.0
          },
          {
            "state": "Sokoto",
            "value": 197.0
          },
          {
            "state": "Taraba",
            "value": 129.0
          },
          {
            "state": "Yobe",
            "value": 152.0
          },
          {
            "state": "Zamfara",
            "value": 130.0
          },
          {
            "state": "Kaduna",
            "value": 187.0
          },
          {
            "state": "Kano",
            "value": 164.0
          },
          {
            "state": "Katsina",
            "value": 188.0
          },
          {
            "state": "Kebbi",
            "value": 252.0
          },
          {
            "state": "Kogi",
            "value": 148.0
          },
          {
            "state": "Nasarawa",
            "value": 120.0
          }
        ],
        "national": [
          {
            "state": "2018",
            "value": 132.0
          },
          {
            "state": "North-Central",
            "value": 95.0
          },
          {
            "state": "North-West",
            "value": 187.0
          },
          {
            "state": "South-East",
            "value": 75.0
          },
          {
            "state": "South-South",
            "value": 73.0
          },
          {
            "state": "South-West",
            "value": 62.0
          },
          {
            "state": "North-East",
            "value": 134.0
          }
        ]
      }
    },
    "2008": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "South-South",
            "value": 138.0
          },
          {
            "state": "South-West",
            "value": 89.0
          },
          {
            "state": "South-East",
            "value": 153.0
          },
          {
            "state": "2008",
            "value": 157.0
          },
          {
            "state": "North-Central",
            "value": 135.0
          },
          {
            "state": "North-East",
            "value": 222.0
          },
          {
            "state": "North-West",
            "value": 217.0
          }
        ]
      }
    },
    "2003": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "2003",
            "value": 201.0
          }
        ]
      }
    },
    "1999": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "1999",
            "value": 133.4
          }
        ]
      }
    },
    "1990": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "1990",
            "value": 191.0
          }
        ]
      }
    },
    "2013": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "2013",
            "value": 128.0
          }
        ]
      }
    },
    "2023": {
      "NDHS": {
        "states": [
          {
            "state": "FCT",
            "value": 60.0
          },
          {
            "state": "Benue",
            "value": 53.0
          },
          {
            "state": "Kogi",
            "value": 78.0
          },
          {
            "state": "Kwara",
            "value": 14.0
          },
          {
            "state": "Nasarawa",
            "value": 106.0
          },
          {
            "state": "Niger",
            "value": 49.0
          },
          {
            "state": "Plateau",
            "value": 98.0
          },
          {
            "state": "Adamawa",
            "value": 144.0
          },
          {
            "state": "Bauchi",
            "value": 125.0
          },
          {
            "state": "Borno",
            "value": 86.0
          },
          {
            "state": "Gombe",
            "value": 157.0
          },
          {
            "state": "Taraba",
            "value": 126.0
          },
          {
            "state": "Yobe",
            "value": 145.0
          },
          {
            "state": "Jigawa",
            "value": 161.0
          },
          {
            "state": "Kaduna",
            "value": 153.0
          },
          {
            "state": "Kano",
            "value": 158.0
          },
          {
            "state": "Katsina",
            "value": 105.0
          },
          {
            "state": "Kebbi",
            "value": 159.0
          },
          {
            "state": "Sokoto",
            "value": 109.0
          },
          {
            "state": "Zamfara",
            "value": 119.0
          },
          {
            "state": "Abia",
            "value": 69.0
          },
          {
            "state": "Anambra",
            "value": 72.0
          },
          {
            "state": "Enugu",
            "value": 49.0
          },
          {
            "state": "Delta",
            "value": 33.0
          },
          {
            "state": "Edo",
            "value": 19.0
          },
          {
            "state": "Rivers",
            "value": 54.0
          },
          {
            "state": "Ekiti",
            "value": 44.0
          },
          {
            "state": "Lagos",
            "value": 46.0
          },
          {
            "state": "Ogun",
            "value": 60.0
          },
          {
            "state": "Ondo",
            "value": 15.0
          },
          {
            "state": "Osun",
            "value": 55.0
          },
          {
            "state": "Oyo",
            "value": 23.0
          },
          {
            "state": "Bayelsa",
            "value": 73.0
          },
          {
            "state": "Cross River",
            "value": 60.0
          },
          {
            "state": "Imo",
            "value": 85.0
          },
          {
            "state": "Akwa Ibom",
            "value": 80.0
          },
          {
            "state": "Ebonyi",
            "value": 68.0
          }
        ],
        "national": [
          {
            "state": "North-Central",
            "value": 65.0
          },
          {
            "state": "North-West",
            "value": 140.0
          },
          {
            "state": "South-East",
            "value": 70.0
          },
          {
            "state": "South-South",
            "value": 50.0
          },
          {
            "state": "South-West",
            "value": 42.0
          },
          {
            "state": "2023",
            "value": 110.0
          },
          {
            "state": "North-East",
            "value": 127.0
          }
        ]
      }
    }
  },
  "zero_dose_children": {
    "2013": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "2013",
            "value": 49.4
          }
        ]
      }
    },
    "2018": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "2018",
            "value": 35.0
          }
        ]
      }
    },
    "2023": {
      "NDHS": {
        "states": [
          {
            "state": "FCT",
            "value": 6.200000000000003
          },
          {
            "state": "Benue",
            "value": 32.7
          },
          {
            "state": "Kogi",
            "value": 57.0
          },
          {
            "state": "Nasarawa",
            "value": 20.299999999999997
          },
          {
            "state": "Niger",
            "value": 56.0
          },
          {
            "state": "Plateau",
            "value": 35.3
          },
          {
            "state": "Adamawa",
            "value": 29.099999999999994
          },
          {
            "state": "Bauchi",
            "value": 36.9
          },
          {
            "state": "Borno",
            "value": 31.700000000000003
          },
          {
            "state": "Gombe",
            "value": 34.0
          },
          {
            "state": "Taraba",
            "value": 40.7
          },
          {
            "state": "Yobe",
            "value": 40.4
          },
          {
            "state": "Jigawa",
            "value": 34.3
          },
          {
            "state": "Kaduna",
            "value": 45.6
          },
          {
            "state": "Kano",
            "value": 42.4
          },
          {
            "state": "Katsina",
            "value": 39.8
          },
          {
            "state": "Kebbi",
            "value": 84.0
          },
          {
            "state": "Sokoto",
            "value": 86.5
          },
          {
            "state": "Zamfara",
            "value": 82.6
          },
          {
            "state": "Abia",
            "value": 4.200000000000003
          },
          {
            "state": "Anambra",
            "value": 14.900000000000006
          },
          {
            "state": "Ebonyi",
            "value": 2.5999999999999943
          },
          {
            "state": "Enugu",
            "value": 12.799999999999997
          },
          {
            "state": "Imo",
            "value": 5.599999999999994
          },
          {
            "state": "Akwa Ibom",
            "value": 15.099999999999994
          },
          {
            "state": "Bayelsa",
            "value": 19.099999999999994
          },
          {
            "state": "Cross River",
            "value": 2.799999999999997
          },
          {
            "state": "Delta",
            "value": 7.599999999999994
          },
          {
            "state": "Edo",
            "value": 3.700000000000003
          },
          {
            "state": "Rivers",
            "value": 22.700000000000003
          },
          {
            "state": "Ekiti",
            "value": 6.0
          },
          {
            "state": "Lagos",
            "value": 4.700000000000003
          },
          {
            "state": "Ogun",
            "value": 20.599999999999994
          },
          {
            "state": "Osun",
            "value": 9.400000000000006
          },
          {
            "state": "Oyo",
            "value": 29.900000000000006
          },
          {
            "state": "Kwara",
            "value": 51.7
          },
          {
            "state": "Ondo",
            "value": 23.5
          }
        ],
        "national": [
          {
            "state": "North-Central",
            "value": 39.6
          },
          {
            "state": "North-East",
            "value": 35.7
          },
          {
            "state": "North-West",
            "value": 53.9
          },
          {
            "state": "South-East",
            "value": 6.900000000000006
          },
          {
            "state": "South-South",
            "value": 12.799999999999997
          },
          {
            "state": "South-West",
            "value": 15.599999999999994
          },
          {
            "state": "2023",
            "value": 37.1
          }
        ]
      }
    }
  },
  "act_fever_under_5": {
    "2023": {
      "NDHS": {
        "states": [
          {
            "state": "Abia",
            "value": 82.4
          },
          {
            "state": "Adamawa",
            "value": 44.1
          },
          {
            "state": "Akwa Ibom",
            "value": 90.5
          },
          {
            "state": "Anambra",
            "value": 71.5
          },
          {
            "state": "Bayelsa",
            "value": 52.6
          },
          {
            "state": "Borno",
            "value": 52.2
          },
          {
            "state": "Cross River",
            "value": 70.9
          },
          {
            "state": "Delta",
            "value": 82.0
          },
          {
            "state": "Ebonyi",
            "value": 76.4
          },
          {
            "state": "Edo",
            "value": 71.1
          },
          {
            "state": "Enugu",
            "value": 55.7
          },
          {
            "state": "FCT",
            "value": 57.2
          },
          {
            "state": "Gombe",
            "value": 21.0
          },
          {
            "state": "Imo",
            "value": 86.9
          },
          {
            "state": "Jigawa",
            "value": 69.8
          },
          {
            "state": "Kaduna",
            "value": 43.7
          },
          {
            "state": "Kano",
            "value": 42.6
          },
          {
            "state": "Katsina",
            "value": 78.6
          },
          {
            "state": "Kebbi",
            "value": 37.4
          },
          {
            "state": "Kogi",
            "value": 42.0
          },
          {
            "state": "Lagos",
            "value": 74.5
          },
          {
            "state": "Nasarawa",
            "value": 43.1
          },
          {
            "state": "Niger",
            "value": 1.7
          },
          {
            "state": "Ogun",
            "value": 65.4
          },
          {
            "state": "Osun",
            "value": 74.7
          },
          {
            "state": "Plateau",
            "value": 59.8
          },
          {
            "state": "Rivers",
            "value": 82.2
          },
          {
            "state": "Yobe",
            "value": 59.1
          },
          {
            "state": "Zamfara",
            "value": 58.9
          }
        ],
        "national": [
          {
            "state": "2023",
            "value": 56.9
          },
          {
            "state": "North-Central",
            "value": 35.9
          },
          {
            "state": "North-East",
            "value": 46.9
          },
          {
            "state": "North-West",
            "value": 51.7
          },
          {
            "state": "South-East",
            "value": 78.6
          },
          {
            "state": "South-South",
            "value": 75.7
          },
          {
            "state": "South-West",
            "value": 71.7
          }
        ]
      }
    },
    "2018": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "2018",
            "value": 52.0
          }
        ]
      }
    },
    "2013": {
      "NDHS": {
        "states": [],
        "national": [
          {
            "state": "2013",
            "value": 6.0
          }
        ]
      }
    }
  },
  "hiv_infants_negative": {
    "2023": {
      "NACA": {
        "states": [],
        "national": [
          {
            "state": "2023",
            "value": 90.0
          }
        ]
      }
    },
    "2024": {
      "NACA": {
        "states": [
          {
            "state": "Borno",
            "value": 100.0
          },
          {
            "state": "Gombe",
            "value": 100.0
          },
          {
            "state": "Taraba",
            "value": 100.0
          },
          {
            "state": "Yobe",
            "value": 100.0
          },
          {
            "state": "Adamawa",
            "value": 99.0
          },
          {
            "state": "Bauchi",
            "value": 99.0
          },
          {
            "state": "Jigawa",
            "value": 100.0
          },
          {
            "state": "Kano",
            "value": 100.0
          },
          {
            "state": "Katsina",
            "value": 100.0
          },
          {
            "state": "Sokoto",
            "value": 100.0
          },
          {
            "state": "Zamfara",
            "value": 100.0
          },
          {
            "state": "Kaduna",
            "value": 96.0
          },
          {
            "state": "Kebbi",
            "value": 0.0
          },
          {
            "state": "Benue",
            "value": 100.0
          },
          {
            "state": "Kwara",
            "value": 100.0
          },
          {
            "state": "Nasarawa",
            "value": 100.0
          },
          {
            "state": "Plateau",
            "value": 97.0
          },
          {
            "state": "FCT",
            "value": 96.0
          },
          {
            "state": "Niger",
            "value": 66.0
          },
          {
            "state": "Kogi",
            "value": 14.0
          },
          {
            "state": "Lagos",
            "value": 100.0
          },
          {
            "state": "Oyo",
            "value": 100.0
          },
          {
            "state": "Osun",
            "value": 98.0
          },
          {
            "state": "Ekiti",
            "value": 97.0
          },
          {
            "state": "Ogun",
            "value": 96.0
          },
          {
            "state": "Ondo",
            "value": 93.0
          },
          {
            "state": "Bayelsa",
            "value": 100.0
          },
          {
            "state": "Akwa Ibom",
            "value": 99.0
          },
          {
            "state": "Delta",
            "value": 99.0
          },
          {
            "state": "Edo",
            "value": 99.0
          },
          {
            "state": "Cross River",
            "value": 98.0
          },
          {
            "state": "Rivers",
            "value": 97.0
          },
          {
            "state": "Ebonyi",
            "value": 100.0
          },
          {
            "state": "Imo",
            "value": 100.0
          },
          {
            "state": "Enugu",
            "value": 94.0
          },
          {
            "state": "Abia",
            "value": 91.0
          },
          {
            "state": "Anambra",
            "value": 0.0
          }
        ],
        "national": [
          {
            "state": "2024",
            "value": 90.0
          }
        ]
      }
    }
  },
  "maternal_mortality_rate": {
    "2024": {
      "MPDSR": {
        "states": [
          {
            "state": "Adamawa",
            "value": 19.0
          },
          {
            "state": "Anambra",
            "value": 0.0
          },
          {
            "state": "Bauchi",
            "value": 2.0
          },
          {
            "state": "Bayelsa",
            "value": 0.0
          },
          {
            "state": "Cross River",
            "value": 0.0
          },
          {
            "state": "Delta",
            "value": 12.0
          },
          {
            "state": "Ebonyi",
            "value": 2.0
          },
          {
            "state": "Edo",
            "value": 0.0
          },
          {
            "state": "Ekiti",
            "value": 12.0
          },
          {
            "state": "FCT",
            "value": 51.0
          },
          {
            "state": "Gombe",
            "value": 62.0
          },
          {
            "state": "Imo",
            "value": 3.0
          },
          {
            "state": "Jigawa",
            "value": 64.0
          },
          {
            "state": "Kaduna",
            "value": 1.0
          },
          {
            "state": "Kano",
            "value": 19.0
          },
          {
            "state": "Katsina",
            "value": 19.0
          },
          {
            "state": "Kebbi",
            "value": 16.0
          },
          {
            "state": "Kogi",
            "value": 1.0
          },
          {
            "state": "Kwara",
            "value": 1.0
          },
          {
            "state": "Nasarawa",
            "value": 24.0
          },
          {
            "state": "Niger",
            "value": 8.0
          },
          {
            "state": "Ogun",
            "value": 9.0
          },
          {
            "state": "Ondo",
            "value": 28.0
          },
          {
            "state": "Osun",
            "value": 2.0
          },
          {
            "state": "Oyo",
            "value": 4.0
          },
          {
            "state": "Plateau",
            "value": 6.0
          },
          {
            "state": "Rivers",
            "value": 0.0
          },
          {
            "state": "Sokoto",
            "value": 9.0
          },
          {
            "state": "Yobe",
            "value": 108.0
          },
          {
            "state": "Zamfara",
            "value": 16.0
          }
        ],
        "national": [
          {
            "state": "2024",
            "value": 498.0
          }
        ]
      },
      "NHMIS DHIS2": {
        "states": [
          {
            "state": "Benue",
            "value": 385.0
          },
          {
            "state": "Abia",
            "value": 230.0
          },
          {
            "state": "Adamawa",
            "value": 183.0
          },
          {
            "state": "Bauchi",
            "value": 381.0
          },
          {
            "state": "Bayelsa",
            "value": 679.0
          },
          {
            "state": "Cross River",
            "value": 201.0
          },
          {
            "state": "Imo",
            "value": 495.0
          },
          {
            "state": "Enugu",
            "value": 157.0
          },
          {
            "state": "Kebbi",
            "value": 379.0
          },
          {
            "state": "Kano",
            "value": 502.0
          },
          {
            "state": "Kwara",
            "value": 79.0
          },
          {
            "state": "Niger",
            "value": 457.0
          },
          {
            "state": "Borno",
            "value": 689.0
          },
          {
            "state": "Anambra",
            "value": 319.0
          },
          {
            "state": "Delta",
            "value": 365.0
          },
          {
            "state": "Gombe",
            "value": 429.0
          },
          {
            "state": "Ekiti",
            "value": 406.0
          },
          {
            "state": "Kogi",
            "value": 439.0
          },
          {
            "state": "Lagos",
            "value": 495.0
          },
          {
            "state": "Ogun",
            "value": 351.0
          },
          {
            "state": "Osun",
            "value": 132.0
          },
          {
            "state": "Oyo",
            "value": 370.0
          },
          {
            "state": "Edo",
            "value": 347.0
          },
          {
            "state": "Yobe",
            "value": 413.0
          },
          {
            "state": "FCT",
            "value": 397.0
          },
          {
            "state": "Jigawa",
            "value": 361.0
          },
          {
            "state": "Ondo",
            "value": 373.0
          },
          {
            "state": "Katsina",
            "value": 705.0
          },
          {
            "state": "Nasarawa",
            "value": 258.0
          },
          {
            "state": "Rivers",
            "value": 281.0
          },
          {
            "state": "Plateau",
            "value": 438.0
          },
          {
            "state": "Sokoto",
            "value": 1074.0
          },
          {
            "state": "Taraba",
            "value": 692.0
          },
          {
            "state": "Zamfara",
            "value": 541.0
          },
          {
            "state": "Kaduna",
            "value": 458.0
          },
          {
            "state": "Akwa Ibom",
            "value": 713.0
          },
          {
            "state": "Ebonyi",
            "value": 425.0
          }
        ],
        "national": [
          {
            "state": "2024",
            "value": 443.0
          }
        ]
      }
    }
  }
};

export const JARDisaggregatedData = {
  "antenatal_care_coverage": {
    "2023": {
      "Mother’s age at birth": [
        {
          "state": "<20",
          "value": 41.3
        },
        {
          "state": "20-34",
          "value": 54.3
        },
        {
          "state": "35-49",
          "value": 51.7
        }
      ],
      "Residence": [
        {
          "state": "Urban",
          "value": 70.5
        },
        {
          "state": "Rural",
          "value": 41.3
        }
      ],
      "Mother's Education": [
        {
          "state": "No education",
          "value": 31.7
        },
        {
          "state": "Primary",
          "value": 54.2
        },
        {
          "state": "Secondary",
          "value": 70.8
        },
        {
          "state": "More than secondary",
          "value": 85.3
        }
      ],
      "Wealth quintile": [
        {
          "state": "Lowest",
          "value": 27.4
        },
        {
          "state": "Second",
          "value": 40.7
        },
        {
          "state": "Middle",
          "value": 53.7
        },
        {
          "state": "Fourth",
          "value": 72.8
        },
        {
          "state": "Highest",
          "value": 84.8
        }
      ],
      "All": [
        {
          "state": "All",
          "value": 52.4
        }
      ]
    }
  },
  "contraceptive_prevalence_rate": {
    "2023": {
      "Number of living children": [
        {
          "state": "0.0",
          "value": 3.5
        },
        {
          "state": "1-2",
          "value": 18.1
        },
        {
          "state": "3-4",
          "value": 27.7
        },
        {
          "state": "5+",
          "value": 19.5
        }
      ],
      "Age": [
        {
          "state": "15-19",
          "value": 4.3
        },
        {
          "state": "20-24",
          "value": 12.8
        },
        {
          "state": "25-29",
          "value": 18.8
        },
        {
          "state": "30-34",
          "value": 22.7
        },
        {
          "state": "35-39",
          "value": 26.6
        },
        {
          "state": "40-44",
          "value": 26.5
        },
        {
          "state": "45-49",
          "value": 20.1
        }
      ],
      "Residence": [
        {
          "state": "Urban",
          "value": 30.6
        },
        {
          "state": "Rural",
          "value": 12.8
        }
      ],
      "Education": [
        {
          "state": "No education",
          "value": 7.4
        },
        {
          "state": "Primary",
          "value": 20.6
        },
        {
          "state": "Secondary",
          "value": 29.9
        },
        {
          "state": "More than secondary",
          "value": 41.3
        }
      ],
      "Wealth quintile": [
        {
          "state": "Lowest",
          "value": 6.0
        },
        {
          "state": "Second",
          "value": 9.7
        },
        {
          "state": "Middle",
          "value": 18.7
        },
        {
          "state": "Fourth",
          "value": 29.9
        },
        {
          "state": "Highest",
          "value": 39.2
        }
      ],
      "All": [
        {
          "state": "All",
          "value": 20.3
        }
      ]
    }
  },
  "penta_3_coverage": {
    "2023": {
      "Gender": [
        {
          "state": "Male",
          "value": 53.1
        },
        {
          "state": "Female",
          "value": 53.8
        }
      ],
      "Birth order": [
        {
          "state": "1.0",
          "value": 54.7
        },
        {
          "state": "2-3",
          "value": 55.6
        },
        {
          "state": "4-5",
          "value": 53.6
        },
        {
          "state": "6+",
          "value": 48.4
        }
      ],
      "Vaccination card": [
        {
          "state": "Seen",
          "value": 84.1
        },
        {
          "state": "Not seen or no longer has",
          "value": 62.7
        },
        {
          "state": "Never had",
          "value": 1.9
        }
      ],
      "Residence": [
        {
          "state": "Urban",
          "value": 65.4
        },
        {
          "state": "Rural",
          "value": 45.5
        }
      ],
      "Mother's Education": [
        {
          "state": "No education",
          "value": 33.7
        },
        {
          "state": "Primary",
          "value": 52.1
        },
        {
          "state": "Secondary",
          "value": 68.6
        },
        {
          "state": "More than secondary",
          "value": 88.6
        }
      ],
      "Wealth quintile": [
        {
          "state": "Lowest",
          "value": 35.7
        },
        {
          "state": "Second",
          "value": 38.5
        },
        {
          "state": "Middle",
          "value": 53.5
        },
        {
          "state": "Fourth",
          "value": 65.7
        },
        {
          "state": "Highest",
          "value": 85.3
        }
      ],
      "All": [
        {
          "state": "All",
          "value": 53.4
        }
      ]
    }
  },
  "infant_mortality_rate": {
    "2023": {
      "Mother's Education": [
        {
          "state": "No education",
          "value": 68.0
        },
        {
          "state": "Primary",
          "value": 63.0
        },
        {
          "state": "Secondary",
          "value": 52.0
        },
        {
          "state": "More than secondary",
          "value": 34.0
        }
      ],
      "Wealth quintile": [
        {
          "state": "Lowest",
          "value": 72.0
        },
        {
          "state": "Second",
          "value": 71.0
        },
        {
          "state": "Middle",
          "value": 54.0
        },
        {
          "state": "Fourth",
          "value": 50.0
        },
        {
          "state": "Highest",
          "value": 39.0
        }
      ],
      "All": [
        {
          "state": "All",
          "value": 63.0
        }
      ]
    }
  },
  "under_five_mortality_rate": {
    "2023": {
      "Mother's Education": [
        {
          "state": "No Education",
          "value": 130.0
        },
        {
          "state": "Primary",
          "value": 108.0
        },
        {
          "state": "Secondary",
          "value": 76.0
        },
        {
          "state": "More than secondary",
          "value": 43.0
        }
      ],
      "Wealth quintile": [
        {
          "state": "Lowest",
          "value": 140.0
        },
        {
          "state": "Secondary",
          "value": 136.0
        },
        {
          "state": "Middle",
          "value": 93.0
        },
        {
          "state": "Fourth",
          "value": 70.0
        },
        {
          "state": "Highest",
          "value": 49.0
        }
      ],
      "All": [
        {
          "state": "All",
          "value": 110.0
        }
      ]
    }
  },
  "postnatal_care_coverage": {
    "2023": {
      "Mother's age at birth": [
        {
          "state": "<20",
          "value": 32.3
        },
        {
          "state": "20-34",
          "value": 44.8
        },
        {
          "state": "35-49",
          "value": 41.2
        }
      ],
      "Residence": [
        {
          "state": "Urban",
          "value": 63.2
        },
        {
          "state": "Rural",
          "value": 30.3
        }
      ],
      "Mother's Education": [
        {
          "state": "No education",
          "value": 22.1
        },
        {
          "state": "Primary",
          "value": 37.3
        },
        {
          "state": "Secondary",
          "value": 61.6
        },
        {
          "state": "More than secondary",
          "value": 82.7
        }
      ],
      "Wealth quintile": [
        {
          "state": "Lowest",
          "value": 22.0
        },
        {
          "state": "Fourth",
          "value": 25.5
        },
        {
          "state": "Middle",
          "value": 43.0
        },
        {
          "state": "Second",
          "value": 60.4
        },
        {
          "state": "Highest",
          "value": 81.5
        }
      ],
      "All": [
        {
          "state": "All",
          "value": 42.8
        }
      ]
    }
  },
  "zero_dose_children": {
    "2023": {
      "Sex": [
        {
          "state": "Male",
          "value": 38.0
        },
        {
          "state": "Female",
          "value": 36.1
        }
      ],
      "Birth order": [
        {
          "state": "1.0",
          "value": 35.8
        },
        {
          "state": "2-3",
          "value": 34.400000000000006
        },
        {
          "state": "4-5",
          "value": 37.8
        },
        {
          "state": "6+",
          "value": 42.3
        }
      ],
      "Vaccination card": [
        {
          "state": "Seen",
          "value": 5.5
        },
        {
          "state": "Not seen or no longer has",
          "value": 14.299999999999997
        },
        {
          "state": "Never had",
          "value": 97.0
        }
      ],
      "Residence": [
        {
          "state": "Urban",
          "value": 22.299999999999997
        },
        {
          "state": "Rural",
          "value": 46.9
        }
      ],
      "Mother's Education": [
        {
          "state": "No education",
          "value": 59.1
        },
        {
          "state": "Primary",
          "value": 36.8
        },
        {
          "state": "Secondary",
          "value": 18.5
        },
        {
          "state": "More than secondary",
          "value": 5.299999999999997
        }
      ],
      "Wealth quintile": [
        {
          "state": "Lowest",
          "value": 56.8
        },
        {
          "state": "Second",
          "value": 51.9
        },
        {
          "state": "Middle",
          "value": 36.1
        },
        {
          "state": "Fourth",
          "value": 22.5
        },
        {
          "state": "Highest",
          "value": 6.599999999999994
        }
      ],
      "All": [
        {
          "state": "All",
          "value": 37.1
        }
      ]
    }
  },
  "skilled_birth_attendance": {
    "2023": {
      "Mother’s age at birth": [
        {
          "state": "<20",
          "value": 33.4
        },
        {
          "state": "20-34",
          "value": 47.3
        },
        {
          "state": "35-49",
          "value": 46.8
        }
      ],
      "Residence": [
        {
          "state": "Urban",
          "value": 70.2
        },
        {
          "state": "Rural",
          "value": 30.6
        }
      ],
      "Mother's Education": [
        {
          "state": "No education",
          "value": 18.5
        },
        {
          "state": "Primary",
          "value": 43.2
        },
        {
          "state": "Secondary",
          "value": 70.3
        },
        {
          "state": "More than secondary",
          "value": 91.2
        }
      ],
      "Wealth quintile": [
        {
          "state": "Lowest",
          "value": 16.2
        },
        {
          "state": "Second",
          "value": 25.0
        },
        {
          "state": "Middle",
          "value": 46.6
        },
        {
          "state": "Fourth",
          "value": 71.5
        },
        {
          "state": "Highest",
          "value": 91.7
        }
      ],
      "All": [
        {
          "state": "All",
          "value": 45.7
        }
      ]
    }
  },
  "full_immunization_rate": {
    "2023": {
      "Sex": [
        {
          "state": "Male",
          "value": 39.6
        },
        {
          "state": "Female",
          "value": 39.1
        }
      ],
      "Birth order": [
        {
          "state": "1.0",
          "value": 39.1
        },
        {
          "state": "2-3",
          "value": 42.1
        },
        {
          "state": "4-5",
          "value": 38.2
        },
        {
          "state": "6+",
          "value": 36.3
        }
      ],
      "Vaccination card": [
        {
          "state": "Seen",
          "value": 71.7
        },
        {
          "state": "Not seen or no longer has",
          "value": 19.4
        },
        {
          "state": "Never had",
          "value": 0.2
        }
      ],
      "Residence": [
        {
          "state": "Urban",
          "value": 47.7
        },
        {
          "state": "Rural",
          "value": 33.8
        }
      ],
      "Mother's Education": [
        {
          "state": "No education",
          "value": 26.7
        },
        {
          "state": "Primary",
          "value": 37.3
        },
        {
          "state": "Secondary",
          "value": 47.4
        },
        {
          "state": "More than secondary",
          "value": 68.3
        }
      ],
      "Wealth quintile": [
        {
          "state": "Lowest",
          "value": 27.9
        },
        {
          "state": "Second",
          "value": 28.5
        },
        {
          "state": "Middle",
          "value": 39.6
        },
        {
          "state": "Fourth",
          "value": 46.1
        },
        {
          "state": "Highest",
          "value": 62.6
        }
      ],
      "All": [
        {
          "state": "All",
          "value": 39.4
        }
      ]
    }
  }
};

export const JARFacilityFunctionality = [
  {
    "location": "North Central",
    "level": "Total analyzed facilities",
    "count": 1381
  },
  {
    "location": "North Central",
    "level": "Partially functional",
    "count": 138
  },
  {
    "location": "North Central",
    "level": "Functional L1",
    "count": 953
  },
  {
    "location": "North Central",
    "level": "Functional L2",
    "count": 290
  },
  {
    "location": "North East",
    "level": "Total analyzed facilities",
    "count": 1010
  },
  {
    "location": "North East",
    "level": "Partially functional",
    "count": 60
  },
  {
    "location": "North East",
    "level": "Functional L1",
    "count": 594
  },
  {
    "location": "North East",
    "level": "Functional L2",
    "count": 356
  },
  {
    "location": "North West",
    "level": "Total analyzed facilities",
    "count": 2029
  },
  {
    "location": "North West",
    "level": "Partially functional",
    "count": 470
  },
  {
    "location": "North West",
    "level": "Functional L1",
    "count": 1071
  },
  {
    "location": "North West",
    "level": "Functional L2",
    "count": 488
  },
  {
    "location": "South East",
    "level": "Total analyzed facilities",
    "count": 1287
  },
  {
    "location": "South East",
    "level": "Partially functional",
    "count": 203
  },
  {
    "location": "South East",
    "level": "Functional L1",
    "count": 993
  },
  {
    "location": "South East",
    "level": "Functional L2",
    "count": 91
  },
  {
    "location": "South South",
    "level": "Total analyzed facilities",
    "count": 1218
  },
  {
    "location": "South South",
    "level": "Partially functional",
    "count": 212
  },
  {
    "location": "South South",
    "level": "Functional L1",
    "count": 775
  },
  {
    "location": "South South",
    "level": "Functional L2",
    "count": 231
  },
  {
    "location": "South West",
    "level": "Total analyzed facilities",
    "count": 1496
  },
  {
    "location": "South West",
    "level": "Partially functional",
    "count": 106
  },
  {
    "location": "South West",
    "level": "Functional L1",
    "count": 1061
  },
  {
    "location": "South West",
    "level": "Functional L2",
    "count": 329
  },
  {
    "location": "Abia",
    "level": "Total analyzed facilities",
    "count": 193
  },
  {
    "location": "Abia",
    "level": "Non-functional",
    "count": 10
  },
  {
    "location": "Abia",
    "level": "Partially functional",
    "count": 16
  },
  {
    "location": "Abia",
    "level": "Functional L2",
    "count": 29
  },
  {
    "location": "Abia",
    "level": "Functional L1",
    "count": 138
  },
  {
    "location": "Adamawa",
    "level": "Total analyzed facilities",
    "count": 226
  },
  {
    "location": "Adamawa",
    "level": "Non-functional",
    "count": 16
  },
  {
    "location": "Adamawa",
    "level": "Partially functional",
    "count": 32
  },
  {
    "location": "Adamawa",
    "level": "Functional L2",
    "count": 34
  },
  {
    "location": "Adamawa",
    "level": "Functional L1",
    "count": 144
  },
  {
    "location": "Akwa Ibom",
    "level": "Total analyzed facilities",
    "count": 272
  },
  {
    "location": "Akwa Ibom",
    "level": "Non-functional",
    "count": 9
  },
  {
    "location": "Akwa Ibom",
    "level": "Partially functional",
    "count": 31
  },
  {
    "location": "Akwa Ibom",
    "level": "Functional L2",
    "count": 64
  },
  {
    "location": "Akwa Ibom",
    "level": "Functional L1",
    "count": 168
  },
  {
    "location": "Anambra",
    "level": "Total analyzed facilities",
    "count": 213
  },
  {
    "location": "Anambra",
    "level": "Non-functional",
    "count": 8
  },
  {
    "location": "Anambra",
    "level": "Partially functional",
    "count": 9
  },
  {
    "location": "Anambra",
    "level": "Functional L2",
    "count": 22
  },
  {
    "location": "Anambra",
    "level": "Functional L1",
    "count": 174
  },
  {
    "location": "Bauchi",
    "level": "Total analyzed facilities",
    "count": 308
  },
  {
    "location": "Bauchi",
    "level": "Non-functional",
    "count": 34
  },
  {
    "location": "Bauchi",
    "level": "Partially functional",
    "count": 35
  },
  {
    "location": "Bauchi",
    "level": "Functional L2",
    "count": 83
  },
  {
    "location": "Bauchi",
    "level": "Functional L1",
    "count": 156
  },
  {
    "location": "Bayelsa",
    "level": "Total analyzed facilities",
    "count": 100
  },
  {
    "location": "Bayelsa",
    "level": "Non-functional",
    "count": 13
  },
  {
    "location": "Bayelsa",
    "level": "Partially functional",
    "count": 27
  },
  {
    "location": "Bayelsa",
    "level": "Functional L2",
    "count": 14
  },
  {
    "location": "Bayelsa",
    "level": "Functional L1",
    "count": 46
  },
  {
    "location": "Benue",
    "level": "Total analyzed facilities",
    "count": 268
  },
  {
    "location": "Benue",
    "level": "Non-functional",
    "count": 12
  },
  {
    "location": "Benue",
    "level": "Partially functional",
    "count": 13
  },
  {
    "location": "Benue",
    "level": "Functional L2",
    "count": 35
  },
  {
    "location": "Benue",
    "level": "Functional L1",
    "count": 208
  },
  {
    "location": "Borno",
    "level": "Total analyzed facilities",
    "count": 183
  },
  {
    "location": "Borno",
    "level": "Non-functional",
    "count": 6
  },
  {
    "location": "Borno",
    "level": "Partially functional",
    "count": 13
  },
  {
    "location": "Borno",
    "level": "Functional L2",
    "count": 33
  },
  {
    "location": "Borno",
    "level": "Functional L1",
    "count": 131
  },
  {
    "location": "Cross River",
    "level": "Total analyzed facilities",
    "count": 228
  },
  {
    "location": "Cross River",
    "level": "Non-functional",
    "count": 10
  },
  {
    "location": "Cross River",
    "level": "Partially functional",
    "count": 13
  },
  {
    "location": "Cross River",
    "level": "Functional L2",
    "count": 33
  },
  {
    "location": "Cross River",
    "level": "Functional L1",
    "count": 172
  },
  {
    "location": "Delta",
    "level": "Total analyzed facilities",
    "count": 192
  },
  {
    "location": "Delta",
    "level": "Non-functional",
    "count": 9
  },
  {
    "location": "Delta",
    "level": "Partially functional",
    "count": 13
  },
  {
    "location": "Delta",
    "level": "Functional L2",
    "count": 36
  },
  {
    "location": "Delta",
    "level": "Functional L1",
    "count": 134
  },
  {
    "location": "Ebonyi",
    "level": "Total analyzed facilities",
    "count": 127
  },
  {
    "location": "Ebonyi",
    "level": "Non-functional",
    "count": 7
  },
  {
    "location": "Ebonyi",
    "level": "Partially functional",
    "count": 9
  },
  {
    "location": "Ebonyi",
    "level": "Functional L2",
    "count": 22
  },
  {
    "location": "Ebonyi",
    "level": "Functional L1",
    "count": 89
  },
  {
    "location": "Edo",
    "level": "Total analyzed facilities",
    "count": 177
  },
  {
    "location": "Edo",
    "level": "Non-functional",
    "count": 21
  },
  {
    "location": "Edo",
    "level": "Partially functional",
    "count": 19
  },
  {
    "location": "Edo",
    "level": "Functional L2",
    "count": 19
  },
  {
    "location": "Edo",
    "level": "Functional L1",
    "count": 118
  },
  {
    "location": "Ekiti",
    "level": "Total analyzed facilities",
    "count": 147
  },
  {
    "location": "Ekiti",
    "level": "Non-functional",
    "count": 10
  },
  {
    "location": "Ekiti",
    "level": "Partially functional",
    "count": 20
  },
  {
    "location": "Ekiti",
    "level": "Functional L2",
    "count": 23
  },
  {
    "location": "Ekiti",
    "level": "Functional L1",
    "count": 94
  },
  {
    "location": "Enugu",
    "level": "Total analyzed facilities",
    "count": 172
  },
  {
    "location": "Enugu",
    "level": "Non-functional",
    "count": 6
  },
  {
    "location": "Enugu",
    "level": "Partially functional",
    "count": 27
  },
  {
    "location": "Enugu",
    "level": "Functional L2",
    "count": 11
  },
  {
    "location": "Enugu",
    "level": "Functional L1",
    "count": 128
  },
  {
    "location": "Gombe",
    "level": "Total analyzed facilities",
    "count": 117
  },
  {
    "location": "Gombe",
    "level": "Non-functional",
    "count": 12
  },
  {
    "location": "Gombe",
    "level": "Partially functional",
    "count": 14
  },
  {
    "location": "Gombe",
    "level": "Functional L2",
    "count": 19
  },
  {
    "location": "Gombe",
    "level": "Functional L1",
    "count": 72
  },
  {
    "location": "Imo",
    "level": "Total analyzed facilities",
    "count": 213
  },
  {
    "location": "Imo",
    "level": "Non-functional",
    "count": 9
  },
  {
    "location": "Imo",
    "level": "Partially functional",
    "count": 15
  },
  {
    "location": "Imo",
    "level": "Functional L2",
    "count": 28
  },
  {
    "location": "Imo",
    "level": "Functional L1",
    "count": 161
  },
  {
    "location": "Jigawa",
    "level": "Total analyzed facilities",
    "count": 258
  },
  {
    "location": "Jigawa",
    "level": "Non-functional",
    "count": 7
  },
  {
    "location": "Jigawa",
    "level": "Partially functional",
    "count": 7
  },
  {
    "location": "Jigawa",
    "level": "Functional L2",
    "count": 58
  },
  {
    "location": "Jigawa",
    "level": "Functional L1",
    "count": 186
  },
  {
    "location": "Kaduna",
    "level": "Total analyzed facilities",
    "count": 497
  },
  {
    "location": "Kaduna",
    "level": "Non-functional",
    "count": 15
  },
  {
    "location": "Kaduna",
    "level": "Partially functional",
    "count": 27
  },
  {
    "location": "Kaduna",
    "level": "Functional L2",
    "count": 99
  },
  {
    "location": "Kaduna",
    "level": "Functional L1",
    "count": 356
  },
  {
    "location": "Kano",
    "level": "Total analyzed facilities",
    "count": 530
  },
  {
    "location": "Kano",
    "level": "Non-functional",
    "count": 8
  },
  {
    "location": "Kano",
    "level": "Partially functional",
    "count": 16
  },
  {
    "location": "Kano",
    "level": "Functional L2",
    "count": 86
  },
  {
    "location": "Kano",
    "level": "Functional L1",
    "count": 420
  },
  {
    "location": "Katsina",
    "level": "Total analyzed facilities",
    "count": 225
  },
  {
    "location": "Katsina",
    "level": "Non-functional",
    "count": 11
  },
  {
    "location": "Katsina",
    "level": "Partially functional",
    "count": 17
  },
  {
    "location": "Katsina",
    "level": "Functional L2",
    "count": 38
  },
  {
    "location": "Katsina",
    "level": "Functional L1",
    "count": 159
  },
  {
    "location": "Kebbi",
    "level": "Total analyzed facilities",
    "count": 231
  },
  {
    "location": "Kebbi",
    "level": "Non-functional",
    "count": 8
  },
  {
    "location": "Kebbi",
    "level": "Partially functional",
    "count": 25
  },
  {
    "location": "Kebbi",
    "level": "Functional L2",
    "count": 59
  },
  {
    "location": "Kebbi",
    "level": "Functional L1",
    "count": 139
  },
  {
    "location": "Kogi",
    "level": "Total analyzed facilities",
    "count": 193
  },
  {
    "location": "Kogi",
    "level": "Non-functional",
    "count": 9
  },
  {
    "location": "Kogi",
    "level": "Partially functional",
    "count": 23
  },
  {
    "location": "Kogi",
    "level": "Functional L2",
    "count": 34
  },
  {
    "location": "Kogi",
    "level": "Functional L1",
    "count": 127
  },
  {
    "location": "Kwara",
    "level": "Total analyzed facilities",
    "count": 225
  },
  {
    "location": "Kwara",
    "level": "Non-functional",
    "count": 11
  },
  {
    "location": "Kwara",
    "level": "Partially functional",
    "count": 23
  },
  {
    "location": "Kwara",
    "level": "Functional L2",
    "count": 33
  },
  {
    "location": "Kwara",
    "level": "Functional L1",
    "count": 158
  },
  {
    "location": "Lagos",
    "level": "Total analyzed facilities",
    "count": 290
  },
  {
    "location": "Lagos",
    "level": "Non-functional",
    "count": 12
  },
  {
    "location": "Lagos",
    "level": "Partially functional",
    "count": 21
  },
  {
    "location": "Lagos",
    "level": "Functional L2",
    "count": 25
  },
  {
    "location": "Lagos",
    "level": "Functional L1",
    "count": 232
  },
  {
    "location": "Nasarawa",
    "level": "Total analyzed facilities",
    "count": 148
  },
  {
    "location": "Nasarawa",
    "level": "Non-functional",
    "count": 7
  },
  {
    "location": "Nasarawa",
    "level": "Partially functional",
    "count": 9
  },
  {
    "location": "Nasarawa",
    "level": "Functional L2",
    "count": 28
  },
  {
    "location": "Nasarawa",
    "level": "Functional L1",
    "count": 104
  },
  {
    "location": "Niger",
    "level": "Total analyzed facilities",
    "count": 271
  },
  {
    "location": "Niger",
    "level": "Non-functional",
    "count": 12
  },
  {
    "location": "Niger",
    "level": "Partially functional",
    "count": 27
  },
  {
    "location": "Niger",
    "level": "Functional L2",
    "count": 42
  },
  {
    "location": "Niger",
    "level": "Functional L1",
    "count": 190
  },
  {
    "location": "Ogun",
    "level": "Total analyzed facilities",
    "count": 236
  },
  {
    "location": "Ogun",
    "level": "Non-functional",
    "count": 7
  },
  {
    "location": "Ogun",
    "level": "Partially functional",
    "count": 24
  },
  {
    "location": "Ogun",
    "level": "Functional L2",
    "count": 33
  },
  {
    "location": "Ogun",
    "level": "Functional L1",
    "count": 172
  },
  {
    "location": "Ondo",
    "level": "Total analyzed facilities",
    "count": 233
  },
  {
    "location": "Ondo",
    "level": "Non-functional",
    "count": 11
  },
  {
    "location": "Ondo",
    "level": "Partially functional",
    "count": 31
  },
  {
    "location": "Ondo",
    "level": "Functional L2",
    "count": 36
  },
  {
    "location": "Ondo",
    "level": "Functional L1",
    "count": 155
  },
  {
    "location": "Osun",
    "level": "Total analyzed facilities",
    "count": 331
  },
  {
    "location": "Osun",
    "level": "Non-functional",
    "count": 14
  },
  {
    "location": "Osun",
    "level": "Partially functional",
    "count": 46
  },
  {
    "location": "Osun",
    "level": "Functional L2",
    "count": 48
  },
  {
    "location": "Osun",
    "level": "Functional L1",
    "count": 223
  },
  {
    "location": "Oyo",
    "level": "Total analyzed facilities",
    "count": 290
  },
  {
    "location": "Oyo",
    "level": "Non-functional",
    "count": 8
  },
  {
    "location": "Oyo",
    "level": "Partially functional",
    "count": 35
  },
  {
    "location": "Oyo",
    "level": "Functional L2",
    "count": 45
  },
  {
    "location": "Oyo",
    "level": "Functional L1",
    "count": 202
  },
  {
    "location": "Plateau",
    "level": "Total analyzed facilities",
    "count": 209
  },
  {
    "location": "Plateau",
    "level": "Non-functional",
    "count": 9
  },
  {
    "location": "Plateau",
    "level": "Partially functional",
    "count": 31
  },
  {
    "location": "Plateau",
    "level": "Functional L2",
    "count": 30
  },
  {
    "location": "Plateau",
    "level": "Functional L1",
    "count": 139
  },
  {
    "location": "Rivers",
    "level": "Total analyzed facilities",
    "count": 250
  },
  {
    "location": "Rivers",
    "level": "Non-functional",
    "count": 8
  },
  {
    "location": "Rivers",
    "level": "Partially functional",
    "count": 15
  },
  {
    "location": "Rivers",
    "level": "Functional L2",
    "count": 37
  },
  {
    "location": "Rivers",
    "level": "Functional L1",
    "count": 190
  },
  {
    "location": "Sokoto",
    "level": "Total analyzed facilities",
    "count": 225
  },
  {
    "location": "Sokoto",
    "level": "Non-functional",
    "count": 9
  },
  {
    "location": "Sokoto",
    "level": "Partially functional",
    "count": 33
  },
  {
    "location": "Sokoto",
    "level": "Functional L2",
    "count": 35
  },
  {
    "location": "Sokoto",
    "level": "Functional L1",
    "count": 148
  },
  {
    "location": "Taraba",
    "level": "Total analyzed facilities",
    "count": 171
  },
  {
    "location": "Taraba",
    "level": "Non-functional",
    "count": 10
  },
  {
    "location": "Taraba",
    "level": "Partially functional",
    "count": 26
  },
  {
    "location": "Taraba",
    "level": "Functional L2",
    "count": 18
  },
  {
    "location": "Taraba",
    "level": "Functional L1",
    "count": 117
  },
  {
    "location": "Yobe",
    "level": "Total analyzed facilities",
    "count": 140
  },
  {
    "location": "Yobe",
    "level": "Non-functional",
    "count": 9
  },
  {
    "location": "Yobe",
    "level": "Partially functional",
    "count": 11
  },
  {
    "location": "Yobe",
    "level": "Functional L2",
    "count": 15
  },
  {
    "location": "Yobe",
    "level": "Functional L1",
    "count": 105
  },
  {
    "location": "Zamfara",
    "level": "Total analyzed facilities",
    "count": 62
  },
  {
    "location": "Zamfara",
    "level": "Non-functional",
    "count": 7
  },
  {
    "location": "Zamfara",
    "level": "Partially functional",
    "count": 9
  },
  {
    "location": "Zamfara",
    "level": "Functional L2",
    "count": 16
  },
  {
    "location": "Zamfara",
    "level": "Functional L1",
    "count": 30
  },
  {
    "location": "FCT",
    "level": "Total analyzed facilities",
    "count": 115
  },
  {
    "location": "FCT",
    "level": "Non-functional",
    "count": 5
  },
  {
    "location": "FCT",
    "level": "Partially functional",
    "count": 5
  },
  {
    "location": "FCT",
    "level": "Functional L2",
    "count": 11
  },
  {
    "location": "FCT",
    "level": "Functional L1",
    "count": 94
  }
];

export const JARHealthWorkersTraining = [
  {
    "state": "Katsina",
    "value": 57.99999999999999
  },
  {
    "state": "Kaduna",
    "value": 49.0
  },
  {
    "state": "Kano",
    "value": 74.0
  },
  {
    "state": "Kebbi",
    "value": 57.99999999999999
  },
  {
    "state": "Sokoto",
    "value": 79.0
  },
  {
    "state": "Jigawa",
    "value": 50.0
  },
  {
    "state": "Zamfara",
    "value": 27.0
  },
  {
    "state": "Niger",
    "value": 0.0
  },
  {
    "state": "Benue",
    "value": 25.0
  },
  {
    "state": "Plateau",
    "value": 0.0
  },
  {
    "state": "Kogi",
    "value": 0.0
  },
  {
    "state": "Nasarawa",
    "value": 0.0
  },
  {
    "state": "Kwara",
    "value": 53.0
  },
  {
    "state": "FCT",
    "value": 54.0
  },
  {
    "state": "Bauchi",
    "value": 40.0
  },
  {
    "state": "Taraba",
    "value": 37.0
  },
  {
    "state": "Adamawa",
    "value": 69.0
  },
  {
    "state": "Gombe",
    "value": 100.0
  },
  {
    "state": "Yobe",
    "value": 57.99999999999999
  },
  {
    "state": "Borno",
    "value": 61.0
  },
  {
    "state": "Osun",
    "value": 53.0
  },
  {
    "state": "Lagos",
    "value": 17.0
  },
  {
    "state": "Ondo",
    "value": 43.0
  },
  {
    "state": "Ekiti",
    "value": 38.0
  },
  {
    "state": "Oyo",
    "value": 0.0
  },
  {
    "state": "Ogun",
    "value": 0.0
  },
  {
    "state": "Akwa Ibom",
    "value": 76.0
  },
  {
    "state": "Cross River",
    "value": 43.0
  },
  {
    "state": "Bayelsa",
    "value": 72.0
  },
  {
    "state": "Edo",
    "value": 0.0
  },
  {
    "state": "Delta",
    "value": 0.0
  },
  {
    "state": "Rivers",
    "value": 0.0
  },
  {
    "state": "Abia",
    "value": 40.0
  },
  {
    "state": "Imo",
    "value": 50.0
  },
  {
    "state": "Ebonyi",
    "value": 34.0
  },
  {
    "state": "Enugu",
    "value": 0.0
  },
  {
    "state": "Anambra",
    "value": 0.0
  },
  {
    "state": "Katsina",
    "value": 42.0
  },
  {
    "state": "Kaduna",
    "value": 51.0
  },
  {
    "state": "Kano",
    "value": 26.0
  },
  {
    "state": "Kebbi",
    "value": 42.0
  },
  {
    "state": "Sokoto",
    "value": 21.0
  },
  {
    "state": "Jigawa",
    "value": 50.0
  },
  {
    "state": "Zamfara",
    "value": 73.0
  },
  {
    "state": "Niger",
    "value": 100.0
  },
  {
    "state": "Benue",
    "value": 75.0
  },
  {
    "state": "Plateau",
    "value": 100.0
  },
  {
    "state": "Kogi",
    "value": 100.0
  },
  {
    "state": "Nasarawa",
    "value": 100.0
  },
  {
    "state": "Kwara",
    "value": 47.0
  },
  {
    "state": "FCT",
    "value": 46.0
  },
  {
    "state": "Bauchi",
    "value": 60.0
  },
  {
    "state": "Taraba",
    "value": 63.0
  },
  {
    "state": "Adamawa",
    "value": 31.0
  },
  {
    "state": "Gombe",
    "value": 0.0
  },
  {
    "state": "Yobe",
    "value": 42.0
  },
  {
    "state": "Borno",
    "value": 39.0
  },
  {
    "state": "Osun",
    "value": 47.0
  },
  {
    "state": "Lagos",
    "value": 83.0
  },
  {
    "state": "Ondo",
    "value": 56.99999999999999
  },
  {
    "state": "Ekiti",
    "value": 62.0
  },
  {
    "state": "Oyo",
    "value": 100.0
  },
  {
    "state": "Ogun",
    "value": 100.0
  },
  {
    "state": "Akwa Ibom",
    "value": 24.0
  },
  {
    "state": "Cross River",
    "value": 56.99999999999999
  },
  {
    "state": "Bayelsa",
    "value": 28.000000000000004
  },
  {
    "state": "Edo",
    "value": 100.0
  },
  {
    "state": "Delta",
    "value": 100.0
  },
  {
    "state": "Rivers",
    "value": 100.0
  },
  {
    "state": "Abia",
    "value": 60.0
  },
  {
    "state": "Imo",
    "value": 50.0
  },
  {
    "state": "Ebonyi",
    "value": 66.0
  },
  {
    "state": "Enugu",
    "value": 100.0
  },
  {
    "state": "Anambra",
    "value": 100.0
  }
];

export const JARHealthInsurance = [
  {
    "program": "All programs",
    "period": "2023.0",
    "enrollment": 16.8
  },
  {
    "program": "All programs",
    "period": "Q1 2024",
    "enrollment": 16.83
  },
  {
    "program": "All programs",
    "period": "Q2 2024",
    "enrollment": 18.68
  },
  {
    "program": "All programs",
    "period": "Q3 2024",
    "enrollment": 19.19
  },
  {
    "program": "SSHIAs",
    "period": "Q3 2024",
    "enrollment": 7.79
  },
  {
    "program": "NHIA",
    "period": "Q3 2024",
    "enrollment": 7.17
  },
  {
    "program": "BHCPF",
    "period": "Q3 2024",
    "enrollment": 2.4
  },
  {
    "program": "HMOs",
    "period": "Q3 2024",
    "enrollment": 1.82
  },
  {
    "program": "All programs",
    "period": "2025.0",
    "enrollment": 21.1
  },
  {
    "program": "BHCPF",
    "period": "2025.0",
    "enrollment": 2.4
  }
];

export const JARVulnerableFunding = [
  {
    "state": "Delta",
    "period": "2024.0",
    "value": 1846572.0
  },
  {
    "state": "Ekiti",
    "period": "2024.0",
    "value": 437331.0
  },
  {
    "state": "Lagos",
    "period": "2024.0",
    "value": 411339.0
  },
  {
    "state": "Kano",
    "period": "2024.0",
    "value": 245223.0
  },
  {
    "state": "Katsina",
    "period": "2024.0",
    "value": 198897.0
  },
  {
    "state": "Kaduna",
    "period": "2024.0",
    "value": 197129.0
  },
  {
    "state": "Niger",
    "period": "2024.0",
    "value": 121515.0
  },
  {
    "state": "Edo",
    "period": "2024.0",
    "value": 120789.0
  },
  {
    "state": "Borno",
    "period": "2024.0",
    "value": 119426.0
  },
  {
    "state": "Kogi",
    "period": "2024.0",
    "value": 117934.0
  },
  {
    "state": "Jigawa",
    "period": "2024.0",
    "value": 109720.0
  },
  {
    "state": "Ondo",
    "period": "2024.0",
    "value": 103047.0
  },
  {
    "state": "Ogun",
    "period": "2024.0",
    "value": 99547.0
  },
  {
    "state": "Oyo",
    "period": "2024.0",
    "value": 98498.0
  },
  {
    "state": "Enugu",
    "period": "2024.0",
    "value": 98021.0
  },
  {
    "state": "Sokoto",
    "period": "2024.0",
    "value": 96409.0
  },
  {
    "state": "Yobe",
    "period": "2024.0",
    "value": 95745.0
  },
  {
    "state": "Bauchi",
    "period": "2024.0",
    "value": 92819.0
  },
  {
    "state": "Osun",
    "period": "2024.0",
    "value": 91737.0
  },
  {
    "state": "Adamawa",
    "period": "2024.0",
    "value": 89158.0
  },
  {
    "state": "Ebonyi",
    "period": "2024.0",
    "value": 80203.0
  },
  {
    "state": "Nasarawa",
    "period": "2024.0",
    "value": 67826.0
  },
  {
    "state": "Imo",
    "period": "2024.0",
    "value": 65679.0
  },
  {
    "state": "Taraba",
    "period": "2024.0",
    "value": 61191.0
  },
  {
    "state": "Plateau",
    "period": "2024.0",
    "value": 60977.0
  },
  {
    "state": "Gombe",
    "period": "2024.0",
    "value": 59495.0
  },
  {
    "state": "Kebbi",
    "period": "2024.0",
    "value": 59172.0
  },
  {
    "state": "Benue",
    "period": "2024.0",
    "value": 56020.0
  },
  {
    "state": "Kwara",
    "period": "2024.0",
    "value": 53126.0
  },
  {
    "state": "Anambra",
    "period": "2024.0",
    "value": 52265.0
  },
  {
    "state": "FCT",
    "period": "2024.0",
    "value": 46002.0
  },
  {
    "state": "Bayelsa",
    "period": "2024.0",
    "value": 43045.0
  },
  {
    "state": "Abia",
    "period": "2024.0",
    "value": 42403.0
  },
  {
    "state": "Cross River",
    "period": "2024.0",
    "value": 41074.0
  },
  {
    "state": "Zamfara",
    "period": "2024.0",
    "value": 27840.0
  },
  {
    "state": "Rivers",
    "period": "2024.0",
    "value": 21044.0
  },
  {
    "state": "Akwa Ibom",
    "period": "2024.0",
    "value": 12824.0
  },
  {
    "state": "Nigeria",
    "period": "2025.0",
    "value": 6600000.0
  },
  {
    "state": "Nigeria",
    "period": "2024.0",
    "value": 5641042.0
  }
];
